import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'node_modules/graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
    [_ in K]?: never;
};
export type Incremental<T> =
    | T
    | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    Date: { input: unknown; output: unknown };
    DateTime: { input: unknown; output: unknown };
    DateTimeOffset: { input: unknown; output: unknown };
    Decimal: { input: unknown; output: unknown };
    Milliseconds: { input: unknown; output: unknown };
    Seconds: { input: unknown; output: unknown };
};

export type AccordionContainer = Item & {
    access?: Maybe<ItemAccess>;
    accordionContainerContent?: Maybe<TextField>;
    accordionContainerDefaultActiveKey?: Maybe<TextField>;
    accordionContainerHeader?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type AccordionContainerChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContainerFieldArgs = {
    name: Scalars['String']['input'];
};

export type AccordionContainerFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContainerHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionContainerIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionContainerUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type AccordionContainerVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionRow = Item & {
    access?: Maybe<ItemAccess>;
    accordionRowContent?: Maybe<TextField>;
    accordionRowHeader?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type AccordionRowChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionRowFieldArgs = {
    name: Scalars['String']['input'];
};

export type AccordionRowFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionRowHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionRowIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionRowUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type AccordionRowVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertPopupMessage = Item & {
    access?: Maybe<ItemAccess>;
    alertContent?: Maybe<TextField>;
    alertCtaButtonEnabled?: Maybe<CheckboxField>;
    alertCtaButtonLink?: Maybe<TextField>;
    alertCtaButtonText?: Maybe<TextField>;
    alertEnable?: Maybe<CheckboxField>;
    alertEndDate?: Maybe<DateField>;
    alertHeader?: Maybe<TextField>;
    alertStartDate?: Maybe<DateField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type AlertPopupMessageChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertPopupMessageFieldArgs = {
    name: Scalars['String']['input'];
};

export type AlertPopupMessageFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertPopupMessageHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertPopupMessageIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type AlertPopupMessageUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type AlertPopupMessageVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerType = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type BannerTypeChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerTypeFieldArgs = {
    name: Scalars['String']['input'];
};

export type BannerTypeFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerTypeHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerTypeIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type BannerTypeUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type BannerTypeVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLayout = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type BlockLayoutChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLayoutFieldArgs = {
    name: Scalars['String']['input'];
};

export type BlockLayoutFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLayoutHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockLayoutIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type BlockLayoutUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type BlockLayoutVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__MediaItem = Item &
    MediaItem & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        contentImage?: Maybe<ImageField>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        mediaCaption?: Maybe<TextField>;
        mediaType?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        videoSrc?: Maybe<TextField>;
        workflow: ItemWorkflow;
    };

export type C__MediaItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__MediaItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type C__MediaItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__MediaItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__MediaItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type C__MediaItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type C__MediaItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__StandardTemplate = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type C__StandardTemplateChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__StandardTemplateFieldArgs = {
    name: Scalars['String']['input'];
};

export type C__StandardTemplateFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__StandardTemplateHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C__StandardTemplateIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type C__StandardTemplateUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type C__StandardTemplateVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BaseMenu = Item &
    _BaseMenu & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        destination?: Maybe<TextField>;
        displayName: Scalars['String']['output'];
        displayText?: Maybe<TextField>;
        enabled?: Maybe<CheckboxField>;
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        linkTo?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type C___BaseMenuChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BaseMenuFieldArgs = {
    name: Scalars['String']['input'];
};

export type C___BaseMenuFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BaseMenuHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BaseMenuIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type C___BaseMenuUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type C___BaseMenuVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePage = Item &
    _BasePage & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        headerBgImage?: Maybe<ImageField>;
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        name: Scalars['String']['output'];
        pageDescription?: Maybe<TextField>;
        pageTitle?: Maybe<TextField>;
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type C___BasePageChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageFieldArgs = {
    name: Scalars['String']['input'];
};

export type C___BasePageFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type C___BasePageUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type C___BasePageVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageMeta = Item &
    _BasePageMeta & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        name: Scalars['String']['output'];
        pageMetaDescription?: Maybe<TextField>;
        pageMetaImage?: Maybe<ImageField>;
        pageMetaTitle?: Maybe<TextField>;
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type C___BasePageMetaChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageMetaFieldArgs = {
    name: Scalars['String']['input'];
};

export type C___BasePageMetaFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageMetaHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type C___BasePageMetaIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type C___BasePageMetaUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type C___BasePageMetaVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckboxField = ItemField & {
    boolValue?: Maybe<Scalars['Boolean']['output']>;
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type CheckboxFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type CheckboxFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type CheckboxFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type Col = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type ColChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColFieldArgs = {
    name: Scalars['String']['input'];
};

export type ColFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ColUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type ColVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColorCode = Item & {
    access?: Maybe<ItemAccess>;
    buttonBGColor?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    fontColor?: Maybe<TextField>;
    h2Color?: Maybe<TextField>;
    hasChildren: Scalars['Boolean']['output'];
    highlightColor?: Maybe<TextField>;
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    musicWaveColor?: Maybe<TextField>;
    name: Scalars['String']['output'];
    overlayBGColor?: Maybe<TextField>;
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    primaryButtonBGColor?: Maybe<TextField>;
    primaryButtonIconColor?: Maybe<TextField>;
    secondaryButtonBGColor?: Maybe<TextField>;
    secondaryButtonIconColor?: Maybe<TextField>;
    template: ItemTemplate;
    themeColorCode?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type ColorCodeChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColorCodeFieldArgs = {
    name: Scalars['String']['input'];
};

export type ColorCodeFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColorCodeHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColorCodeIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ColorCodeUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type ColorCodeVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSearchFacet = {
    name?: Maybe<Scalars['String']['output']>;
    values?: Maybe<Array<Maybe<ContentSearchFacetValue>>>;
};

export type ContentSearchFacetValuesArgs = {
    hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSearchFacetValue = {
    count?: Maybe<Scalars['Int']['output']>;
    item?: Maybe<Item>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ContentSearchFieldValue = {
    name: Scalars['String']['output'];
    value?: Maybe<Scalars['String']['output']>;
};

export type ContentSearchResult = {
    field?: Maybe<Scalars['String']['output']>;
    fields?: Maybe<Array<Maybe<ContentSearchFieldValue>>>;
    id?: Maybe<Scalars['ID']['output']>;
    item?: Maybe<Item>;
    language?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    path?: Maybe<Scalars['String']['output']>;
    score: Scalars['Float']['output'];
    templateName?: Maybe<Scalars['String']['output']>;
    uri?: Maybe<Scalars['String']['output']>;
    version?: Maybe<Scalars['Int']['output']>;
};

export type ContentSearchResultFieldArgs = {
    name: Scalars['String']['input'];
};

export type ContentSearchResultIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ContentSearchResultConnection = {
    edges?: Maybe<Array<Maybe<ContentSearchResultEdge>>>;
    items?: Maybe<Array<Maybe<ContentSearchResult>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContentSearchResultEdge = {
    cursor: Scalars['String']['output'];
    node?: Maybe<ContentSearchResult>;
};

export type ContentSearchResults = {
    facets?: Maybe<Array<Maybe<ContentSearchFacet>>>;
    results?: Maybe<ContentSearchResultConnection>;
};

export type CrossSellBanner = Item & {
    access?: Maybe<ItemAccess>;
    bannerBgImage?: Maybe<ImageField>;
    bannerType?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    generalContent?: Maybe<TextField>;
    generalCtaEnable?: Maybe<CheckboxField>;
    generalCtaLink?: Maybe<TextField>;
    generalCtaText?: Maybe<TextField>;
    generalHeader?: Maybe<TextField>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    partyCtaEnable?: Maybe<CheckboxField>;
    partyCtaLink?: Maybe<TextField>;
    partyLink?: Maybe<LookupField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type CrossSellBannerChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrossSellBannerFieldArgs = {
    name: Scalars['String']['input'];
};

export type CrossSellBannerFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrossSellBannerHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrossSellBannerIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type CrossSellBannerUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type CrossSellBannerVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    dateValue?: Maybe<Scalars['Int']['output']>;
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    formattedDateValue?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type DateFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type DateFieldFormattedDateValueArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DateFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type DateFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type DiningSingleBlock = Item & {
    access?: Maybe<ItemAccess>;
    blockLayout?: Maybe<TextField>;
    buttonLink?: Maybe<TextField>;
    buttonText?: Maybe<TextField>;
    buttonType?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    diningDescription?: Maybe<TextField>;
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    subHeaderTitle?: Maybe<TextField>;
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    venueLink?: Maybe<LookupField>;
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type DiningSingleBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiningSingleBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type DiningSingleBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiningSingleBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DiningSingleBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type DiningSingleBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type DiningSingleBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    description?: Maybe<Scalars['String']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    extension?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    keywords?: Maybe<Scalars['String']['output']>;
    mimeType?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    size?: Maybe<Scalars['Int']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type FileFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type FileFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type FileFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralPageItem = Item &
    _BasePage &
    _BasePageMeta & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        headerBgImage?: Maybe<ImageField>;
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        name: Scalars['String']['output'];
        pageDescription?: Maybe<TextField>;
        pageMetaDescription?: Maybe<TextField>;
        pageMetaImage?: Maybe<ImageField>;
        pageMetaTitle?: Maybe<TextField>;
        pageTitle?: Maybe<TextField>;
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type GeneralPageItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneralPageItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type GeneralPageItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneralPageItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneralPageItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralPageItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type GeneralPageItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderMenu = Item &
    _BaseMenu & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        destination?: Maybe<TextField>;
        displayName: Scalars['String']['output'];
        displayText?: Maybe<TextField>;
        enabled?: Maybe<CheckboxField>;
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        footerMenu?: Maybe<CheckboxField>;
        hasChildren: Scalars['Boolean']['output'];
        headerMenu?: Maybe<CheckboxField>;
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        linkTo?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type HeaderMenuChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderMenuFieldArgs = {
    name: Scalars['String']['input'];
};

export type HeaderMenuFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderMenuHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderMenuIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HeaderMenuUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HeaderMenuVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSlide = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    contentCtaEnable?: Maybe<CheckboxField>;
    contentCtaLink?: Maybe<TextField>;
    contentCtaText?: Maybe<TextField>;
    contentHeader?: Maybe<TextField>;
    contentImage?: Maybe<ImageField>;
    contentImageLink?: Maybe<TextField>;
    contentImageLinkEnable?: Maybe<CheckboxField>;
    contentSubHeader?: Maybe<TextField>;
    contentText?: Maybe<TextField>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    layoutType?: Maybe<TextField>;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type HomepageContentSlideChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSlideFieldArgs = {
    name: Scalars['String']['input'];
};

export type HomepageContentSlideFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSlideHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSlideIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageContentSlideUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HomepageContentSlideVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSlider = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type HomepageContentSliderChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSliderFieldArgs = {
    name: Scalars['String']['input'];
};

export type HomepageContentSliderFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSliderHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageContentSliderIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageContentSliderUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HomepageContentSliderVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type HomepageHeroBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type HomepageHeroBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageHeroBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HomepageHeroBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroItem = Item & {
    access?: Maybe<ItemAccess>;
    backgroundVideoSrc?: Maybe<TextField>;
    cardCategory?: Maybe<TextField>;
    cardDuration?: Maybe<NumberField>;
    cardTitle?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    ctaEnable?: Maybe<CheckboxField>;
    ctaIcon?: Maybe<TextField>;
    ctaLink?: Maybe<TextField>;
    ctaText?: Maybe<TextField>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    enable?: Maybe<CheckboxField>;
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    heroBackground?: Maybe<ImageField>;
    heroBackgroundLink?: Maybe<TextField>;
    heroMobileBackground?: Maybe<ImageField>;
    heroTitle?: Maybe<TextField>;
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    videoEnable?: Maybe<CheckboxField>;
    videoPoster?: Maybe<ImageField>;
    videoSrc?: Maybe<TextField>;
    workflow: ItemWorkflow;
};

export type HomepageHeroItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type HomepageHeroItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageHeroItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageHeroItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HomepageHeroItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgContainer = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    igBlockBgImage?: Maybe<ImageField>;
    igBlockContent?: Maybe<TextField>;
    igBlockHeader?: Maybe<TextField>;
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type HomepageIgContainerChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgContainerFieldArgs = {
    name: Scalars['String']['input'];
};

export type HomepageIgContainerFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgContainerHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgContainerIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageIgContainerUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HomepageIgContainerVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgPost = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    igPostContent?: Maybe<TextField>;
    igPostImage?: Maybe<ImageField>;
    igPostLink?: Maybe<TextField>;
    igPostTitle?: Maybe<TextField>;
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type HomepageIgPostChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgPostFieldArgs = {
    name: Scalars['String']['input'];
};

export type HomepageIgPostFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgPostHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomepageIgPostIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageIgPostUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type HomepageIgPostVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    imageCaption?: Maybe<TextField>;
    imageLightboxEnable?: Maybe<CheckboxField>;
    imageSelection?: Maybe<ImageField>;
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type ImageChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageFieldArgs = {
    name: Scalars['String']['input'];
};

export type ImageFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ImageUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type ImageVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageField = ItemField & {
    alt?: Maybe<Scalars['String']['output']>;
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    description?: Maybe<Scalars['String']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    extension?: Maybe<Scalars['String']['output']>;
    height?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    keywords?: Maybe<Scalars['String']['output']>;
    mimeType?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    size?: Maybe<Scalars['Int']['output']>;
    src?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['Int']['output']>;
};

export type ImageFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ImageFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ImageFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ImageFieldSrcArgs = {
    maxHeight?: InputMaybe<Scalars['Int']['input']>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type InLineBusModal = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    remark?: Maybe<TextField>;
    subTitle?: Maybe<TextField>;
    template: ItemTemplate;
    title?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type InLineBusModalChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusModalFieldArgs = {
    name: Scalars['String']['input'];
};

export type InLineBusModalFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusModalHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusModalIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type InLineBusModalUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type InLineBusModalVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusTableRow = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    combineFromAndTo?: Maybe<CheckboxField>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    from?: Maybe<TextField>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    operators?: Maybe<TextField>;
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    routeNo?: Maybe<TextField>;
    template: ItemTemplate;
    to?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type InLineBusTableRowChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusTableRowFieldArgs = {
    name: Scalars['String']['input'];
};

export type InLineBusTableRowFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusTableRowHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InLineBusTableRowIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type InLineBusTableRowUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type InLineBusTableRowVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertOptions = {
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
};

export type InsertOptionsIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type IntegerField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    intValue?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type IntegerFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type IntegerFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type IntegerFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type Item = {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type ItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type ItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type ItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemAccess = {
    canAddBranch?: Maybe<Scalars['Boolean']['output']>;
    canAddTemplate?: Maybe<Scalars['Boolean']['output']>;
    canAdmin?: Maybe<Scalars['Boolean']['output']>;
    canCopyTo?: Maybe<Scalars['Boolean']['output']>;
    canCreate?: Maybe<Scalars['Boolean']['output']>;
    canDelete?: Maybe<Scalars['Boolean']['output']>;
    canDuplicate?: Maybe<Scalars['Boolean']['output']>;
    canMoveTo?: Maybe<Scalars['Boolean']['output']>;
    canRead?: Maybe<Scalars['Boolean']['output']>;
    canReadLanguage?: Maybe<Scalars['Boolean']['output']>;
    canRemoveVersion?: Maybe<Scalars['Boolean']['output']>;
    canRename?: Maybe<Scalars['Boolean']['output']>;
    canWrite?: Maybe<Scalars['Boolean']['output']>;
    canWriteLanguage?: Maybe<Scalars['Boolean']['output']>;
};

export type ItemAccessCanAddBranchArgs = {
    branchId?: InputMaybe<Scalars['String']['input']>;
};

export type ItemAccessCanAddTemplateArgs = {
    templateId?: InputMaybe<Scalars['String']['input']>;
};

export type ItemAccessCanCopyToArgs = {
    itemId?: InputMaybe<Scalars['String']['input']>;
};

export type ItemAccessCanMoveToArgs = {
    itemId?: InputMaybe<Scalars['String']['input']>;
};

export type ItemField = {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ItemFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ItemFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ItemLanguage = {
    displayName: Scalars['String']['output'];
    englishName: Scalars['String']['output'];
    icon?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    nativeName: Scalars['String']['output'];
};

export type ItemSearchFieldQuery = {
    name: Scalars['String']['input'];
    value: Scalars['String']['input'];
};

export type ItemTemplate = InsertOptions & {
    baseTemplates?: Maybe<Array<Maybe<ItemTemplate>>>;
    fields?: Maybe<Array<Maybe<ItemTemplateField>>>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    ownFields?: Maybe<Array<Maybe<ItemTemplateField>>>;
};

export type ItemTemplateIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemTemplateField = {
    id?: Maybe<Scalars['ID']['output']>;
    name: Scalars['String']['output'];
    section: Scalars['String']['output'];
    sectionSortOrder: Scalars['Int']['output'];
    shared: Scalars['Boolean']['output'];
    sortOrder: Scalars['Int']['output'];
    source: Scalars['String']['output'];
    title: Scalars['String']['output'];
    type: Scalars['String']['output'];
    unversioned: Scalars['Boolean']['output'];
};

export type ItemTemplateFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ItemUrlOptions = {
    alwaysIncludeServerUrl?: InputMaybe<Scalars['Boolean']['input']>;
    disableLanguageEmbedding?: InputMaybe<Scalars['Boolean']['input']>;
    language?: InputMaybe<Scalars['String']['input']>;
    siteName?: InputMaybe<Scalars['String']['input']>;
};

export type ItemWorkflow = {
    canEdit: Scalars['Boolean']['output'];
    canSave: Scalars['Boolean']['output'];
    workflowId?: Maybe<Scalars['String']['output']>;
    workflowName?: Maybe<Scalars['String']['output']>;
    workflowState?: Maybe<ItemWorkflowState>;
};

export type ItemWorkflowState = {
    final?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type LayoutField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    device?: Maybe<LayoutFieldDevice>;
    devices?: Maybe<Array<Maybe<LayoutFieldDevice>>>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type LayoutFieldDeviceArgs = {
    id?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutFieldDevice = {
    device?: Maybe<Item>;
    id?: Maybe<Scalars['String']['output']>;
    layout?: Maybe<Item>;
    layoutId?: Maybe<Scalars['String']['output']>;
    renderings?: Maybe<Array<Maybe<LayoutFieldRendering>>>;
};

export type LayoutFieldRendering = {
    datasource?: Maybe<Scalars['String']['output']>;
    datasourceItem?: Maybe<Item>;
    id?: Maybe<Scalars['String']['output']>;
    parameters?: Maybe<Scalars['String']['output']>;
    placeholder?: Maybe<Scalars['String']['output']>;
    renderingItem?: Maybe<Item>;
};

export type LinkField = ItemField & {
    anchor?: Maybe<Scalars['String']['output']>;
    canWrite: Scalars['Boolean']['output'];
    className?: Maybe<Scalars['String']['output']>;
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    linkType?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    queryString?: Maybe<Scalars['String']['output']>;
    rendered?: Maybe<Scalars['String']['output']>;
    target?: Maybe<Scalars['String']['output']>;
    targetItem?: Maybe<Item>;
    text?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type LinkFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type LinkFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type LinkFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type LookupField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    targetId?: Maybe<Scalars['ID']['output']>;
    targetItem?: Maybe<Item>;
    value?: Maybe<Scalars['String']['output']>;
};

export type LookupFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type LookupFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type LookupFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type LookupFieldTargetIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type MediaItem = {
    contentImage?: Maybe<ImageField>;
    mediaCaption?: Maybe<TextField>;
    mediaType?: Maybe<TextField>;
    videoSrc?: Maybe<TextField>;
};

export type MediaType = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type MediaTypeChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaTypeFieldArgs = {
    name: Scalars['String']['input'];
};

export type MediaTypeFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaTypeHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaTypeIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type MediaTypeUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type MediaTypeVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Menu = Item &
    _BaseMenu & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        destination?: Maybe<TextField>;
        displayName: Scalars['String']['output'];
        displayText?: Maybe<TextField>;
        enabled?: Maybe<CheckboxField>;
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        linkTo?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type MenuChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuFieldArgs = {
    name: Scalars['String']['input'];
};

export type MenuFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type MenuUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type MenuVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuTarget = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type MenuTargetChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuTargetFieldArgs = {
    name: Scalars['String']['input'];
};

export type MenuTargetFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuTargetHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuTargetIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type MenuTargetUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type MenuTargetVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultilistField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    count?: Maybe<Scalars['Int']['output']>;
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    targetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    targetItems?: Maybe<Array<Maybe<Item>>>;
    value?: Maybe<Scalars['String']['output']>;
};

export type MultilistFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type MultilistFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type MultilistFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type NameValueListField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
    values?: Maybe<Array<Maybe<NameValueListValue>>>;
};

export type NameValueListFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type NameValueListFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type NameValueListFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type NameValueListValue = {
    name: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type NumberField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    numberValue?: Maybe<Scalars['Float']['output']>;
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type NumberFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type NumberFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type NumberFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type OldSiteUrlList = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    redirectList?: Maybe<TextField>;
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type OldSiteUrlListChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OldSiteUrlListFieldArgs = {
    name: Scalars['String']['input'];
};

export type OldSiteUrlListFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OldSiteUrlListHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OldSiteUrlListIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type OldSiteUrlListUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type OldSiteUrlListVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OtherDiningOptions = Item & {
    access?: Maybe<ItemAccess>;
    buttonLink?: Maybe<TextField>;
    buttonText?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    diningOptions?: Maybe<MultilistField>;
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    sectionTitle?: Maybe<TextField>;
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type OtherDiningOptionsChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OtherDiningOptionsFieldArgs = {
    name: Scalars['String']['input'];
};

export type OtherDiningOptionsFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OtherDiningOptionsHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OtherDiningOptionsIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type OtherDiningOptionsUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type OtherDiningOptionsVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageInfo = {
    endCursor?: Maybe<Scalars['String']['output']>;
    hasNextPage: Scalars['Boolean']['output'];
    hasPreviousPage: Scalars['Boolean']['output'];
    startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageRow = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    desktopColumnStyle?: Maybe<LookupField>;
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    mobileColumnStyle?: Maybe<LookupField>;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PageRowChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowFieldArgs = {
    name: Scalars['String']['input'];
};

export type PageRowFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PageRowUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PageRowVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowColumn = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PageRowColumnChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowColumnFieldArgs = {
    name: Scalars['String']['input'];
};

export type PageRowColumnFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowColumnHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageRowColumnIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PageRowColumnUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PageRowColumnVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    partnerBlockHeader?: Maybe<TextField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartnerBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartnerBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartnerBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerLogo = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    clickEventID?: Maybe<TextField>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    logoImage?: Maybe<ImageField>;
    logoLink?: Maybe<TextField>;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartnerLogoChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerLogoFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartnerLogoFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerLogoHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerLogoIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerLogoUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartnerLogoVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Party = Item &
    _BasePageMeta & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        ctaButtonText?: Maybe<TextField>;
        ctaButtonUrl?: Maybe<TextField>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        endDatetime?: Maybe<DateField>;
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        homeCardCTAButtonText?: Maybe<TextField>;
        homeCardCTAButtonUrl?: Maybe<TextField>;
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        name: Scalars['String']['output'];
        pageMetaDescription?: Maybe<TextField>;
        pageMetaImage?: Maybe<ImageField>;
        pageMetaTitle?: Maybe<TextField>;
        parent?: Maybe<Item>;
        partyColorCode?: Maybe<LookupField>;
        partyDateText?: Maybe<TextField>;
        partyDescription?: Maybe<TextField>;
        partyImage?: Maybe<ImageField>;
        partyName?: Maybe<TextField>;
        path: Scalars['String']['output'];
        startDatetime?: Maybe<DateField>;
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type PartyChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    layoutBlock?: Maybe<TextField>;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyAlbumBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyAlbumBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyAlbumBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyAlbumBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumItem = Item &
    MediaItem & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        contentImage?: Maybe<ImageField>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        mediaCaption?: Maybe<TextField>;
        mediaType?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        videoSrc?: Maybe<TextField>;
        workflow: ItemWorkflow;
    };

export type PartyAlbumItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyAlbumItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyAlbumItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyAlbumItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyAlbumItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyCardBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyCardBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyCardBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyCardBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardIcon = Item & {
    access?: Maybe<ItemAccess>;
    cardIcon?: Maybe<ImageField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyCardIconChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardIconFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyCardIconFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardIconHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardIconIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyCardIconUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyCardIconVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardRow = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    iconImage?: Maybe<LookupField>;
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    rowContent?: Maybe<TextField>;
    rowTitle?: Maybe<TextField>;
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyCardRowChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardRowFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyCardRowFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardRowHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardRowIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyCardRowUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyCardRowVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardState = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyCardStateChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardStateFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyCardStateFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardStateHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyCardStateIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyCardStateUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyCardStateVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDate = Item & {
    access?: Maybe<ItemAccess>;
    albumPath?: Maybe<ReferenceField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    partyCardImage?: Maybe<ImageField>;
    partyCardState?: Maybe<LookupField>;
    partyCardText?: Maybe<TextField>;
    partyCardTitle?: Maybe<TextField>;
    partyDateTime?: Maybe<DateField>;
    partyEndDateTime?: Maybe<DateField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyDateChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyDateFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyDateUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyDateVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateFolder = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyDateFolderChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateFolderFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyDateFolderFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateFolderHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDateFolderIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyDateFolderUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyDateFolderVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDetailPageItem = Item &
    _BasePage &
    _BasePageMeta & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        headerBgImage?: Maybe<ImageField>;
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        name: Scalars['String']['output'];
        pageDescription?: Maybe<TextField>;
        pageMetaDescription?: Maybe<TextField>;
        pageMetaImage?: Maybe<ImageField>;
        pageMetaTitle?: Maybe<TextField>;
        pageTitle?: Maybe<TextField>;
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type PartyDetailPageItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDetailPageItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyDetailPageItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDetailPageItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyDetailPageItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyDetailPageItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyDetailPageItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyInfoBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    parties?: Maybe<MultilistField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    title?: Maybe<TextField>;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyInfoBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyInfoBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyInfoBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyInfoBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyInfoBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyInfoBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyInfoBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyIntroBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    partyIntroContent?: Maybe<TextField>;
    partyIntroTitle?: Maybe<TextField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyIntroBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyIntroBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyIntroBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyIntroBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyIntroBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyIntroBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyIntroBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartySchedule = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    parties?: Maybe<MultilistField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PartyScheduleChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyScheduleFieldArgs = {
    name: Scalars['String']['input'];
};

export type PartyScheduleFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyScheduleHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyScheduleIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PartyScheduleUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PartyScheduleVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbum = Item & {
    access?: Maybe<ItemAccess>;
    albumCaption?: Maybe<TextField>;
    albumDate?: Maybe<DateField>;
    albumImage?: Maybe<ImageField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    enabled?: Maybe<CheckboxField>;
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PhotoAlbumChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumFieldArgs = {
    name: Scalars['String']['input'];
};

export type PhotoAlbumFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoAlbumUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PhotoAlbumVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBlock = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    parties?: Maybe<MultilistField>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PhotoAlbumBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type PhotoAlbumBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoAlbumBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PhotoAlbumBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBulk = Item & {
    access?: Maybe<ItemAccess>;
    albumCaption?: Maybe<TextField>;
    albumDate?: Maybe<DateField>;
    albumImage?: Maybe<ImageField>;
    albumSelection?: Maybe<MultilistField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    enabled?: Maybe<CheckboxField>;
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PhotoAlbumBulkChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBulkFieldArgs = {
    name: Scalars['String']['input'];
};

export type PhotoAlbumBulkFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBulkHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumBulkIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoAlbumBulkUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PhotoAlbumBulkVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumMedia = Item &
    MediaItem & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        contentImage?: Maybe<ImageField>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        mediaCaption?: Maybe<TextField>;
        mediaType?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        videoSrc?: Maybe<TextField>;
        workflow: ItemWorkflow;
    };

export type PhotoAlbumMediaChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumMediaFieldArgs = {
    name: Scalars['String']['input'];
};

export type PhotoAlbumMediaFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumMediaHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumMediaIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoAlbumMediaUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PhotoAlbumMediaVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumsFolder = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type PhotoAlbumsFolderChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumsFolderFieldArgs = {
    name: Scalars['String']['input'];
};

export type PhotoAlbumsFolderFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumsFolderHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhotoAlbumsFolderIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoAlbumsFolderUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type PhotoAlbumsFolderVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
    item?: Maybe<Item>;
    search?: Maybe<ContentSearchResults>;
};

export type QueryItemArgs = {
    language?: InputMaybe<Scalars['String']['input']>;
    path?: InputMaybe<Scalars['String']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySearchArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    facetOn?: InputMaybe<Array<Scalars['String']['input']>>;
    fieldsEqual?: InputMaybe<Array<InputMaybe<ItemSearchFieldQuery>>>;
    first?: InputMaybe<Scalars['Int']['input']>;
    index?: InputMaybe<Scalars['String']['input']>;
    keyword?: InputMaybe<Scalars['String']['input']>;
    language?: InputMaybe<Scalars['String']['input']>;
    latestVersion?: InputMaybe<Scalars['Boolean']['input']>;
    rootItem?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    path?: Maybe<Scalars['String']['output']>;
    rendered?: Maybe<Scalars['String']['output']>;
    targetId?: Maybe<Scalars['ID']['output']>;
    targetItem?: Maybe<Item>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ReferenceFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceFieldTargetIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type RichText = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    richTextContent?: Maybe<TextField>;
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type RichTextChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RichTextFieldArgs = {
    name: Scalars['String']['input'];
};

export type RichTextFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RichTextHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RichTextIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type RichTextUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type RichTextVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Row = Item & {
    access?: Maybe<ItemAccess>;
    buttonAEnable?: Maybe<CheckboxField>;
    buttonALink?: Maybe<TextField>;
    buttonAText?: Maybe<TextField>;
    buttonBEnable?: Maybe<CheckboxField>;
    buttonBLink?: Maybe<TextField>;
    buttonBText?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    rowContent?: Maybe<TextField>;
    rowHeader?: Maybe<TextField>;
    rowLayout?: Maybe<TextField>;
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type RowChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowFieldArgs = {
    name: Scalars['String']['input'];
};

export type RowFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type RowUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type RowVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowLayout = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type RowLayoutChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowLayoutFieldArgs = {
    name: Scalars['String']['input'];
};

export type RowLayoutFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowLayoutHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowLayoutIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type RowLayoutUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type RowLayoutVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteGlobalConfiguration = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    defaultMetaDescription?: Maybe<TextField>;
    defaultMetaImage?: Maybe<ImageField>;
    defaultMetaTitle?: Maybe<TextField>;
    defaultMetaTitleSuffix?: Maybe<TextField>;
    displayName: Scalars['String']['output'];
    ewinLogo?: Maybe<ImageField>;
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hKJCLogo?: Maybe<ImageField>;
    hasChildren: Scalars['Boolean']['output'];
    headerCTAButtonEnable?: Maybe<CheckboxField>;
    headerCTAButtonLink?: Maybe<TextField>;
    headerCTAButtonText?: Maybe<TextField>;
    hwFooterLogo?: Maybe<ImageField>;
    hwHeaderLogo?: Maybe<ImageField>;
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    masterColorCode?: Maybe<LookupField>;
    mobileHKJCLogo?: Maybe<ImageField>;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    redirectButtonText?: Maybe<TextField>;
    redirectPopupContent?: Maybe<TextField>;
    redirectPopupTitle?: Maybe<TextField>;
    rgpContent?: Maybe<TextField>;
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type SiteGlobalConfigurationChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteGlobalConfigurationFieldArgs = {
    name: Scalars['String']['input'];
};

export type SiteGlobalConfigurationFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteGlobalConfigurationHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteGlobalConfigurationIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type SiteGlobalConfigurationUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type SiteGlobalConfigurationVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialMediaItem = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    socialIcon?: Maybe<ImageField>;
    socialLink?: Maybe<TextField>;
    socialName?: Maybe<TextField>;
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type SocialMediaItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialMediaItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type SocialMediaItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialMediaItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialMediaItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type SocialMediaItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubMenu = Item &
    _BaseMenu & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        destination?: Maybe<TextField>;
        displayName: Scalars['String']['output'];
        displayText?: Maybe<TextField>;
        enabled?: Maybe<CheckboxField>;
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        linkTo?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type SubMenuChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubMenuFieldArgs = {
    name: Scalars['String']['input'];
};

export type SubMenuFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubMenuHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubMenuIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type SubMenuUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type SubMenuVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Testimonial = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    contributor?: Maybe<TextField>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    testimonialContent?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type TestimonialChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialFieldArgs = {
    name: Scalars['String']['input'];
};

export type TestimonialFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type TestimonialUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type TestimonialVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialBlock = Item & {
    access?: Maybe<ItemAccess>;
    bgImage?: Maybe<ImageField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type TestimonialBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type TestimonialBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestimonialBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type TestimonialBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type TestimonialBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextField = ItemField & {
    canWrite: Scalars['Boolean']['output'];
    containsFallbackValue: Scalars['Boolean']['output'];
    containsInheritedValue: Scalars['Boolean']['output'];
    containsStandardValue: Scalars['Boolean']['output'];
    definition?: Maybe<ItemTemplateField>;
    displayName?: Maybe<Scalars['String']['output']>;
    editable?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    rendered?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type TextFieldEditableArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type TextFieldIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type TextFieldRenderedArgs = {
    fieldRendererParameters?: InputMaybe<Scalars['String']['input']>;
};

export type ThreeBlocks = Item & {
    access?: Maybe<ItemAccess>;
    blockAContent?: Maybe<TextField>;
    blockACtaButtonLink?: Maybe<TextField>;
    blockACtaButtonText?: Maybe<TextField>;
    blockAImage?: Maybe<ImageField>;
    blockATitle?: Maybe<TextField>;
    blockBContent?: Maybe<TextField>;
    blockBCtaButtonLink?: Maybe<TextField>;
    blockBCtaButtonText?: Maybe<TextField>;
    blockBImage?: Maybe<ImageField>;
    blockBTitle?: Maybe<TextField>;
    blockCContent?: Maybe<TextField>;
    blockCCtaButtonLink?: Maybe<TextField>;
    blockCCtaButtonText?: Maybe<TextField>;
    blockCImage?: Maybe<ImageField>;
    blockCTitle?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type ThreeBlocksChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThreeBlocksFieldArgs = {
    name: Scalars['String']['input'];
};

export type ThreeBlocksFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThreeBlocksHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThreeBlocksIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type ThreeBlocksUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type ThreeBlocksVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TitleIconType = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type TitleIconTypeChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TitleIconTypeFieldArgs = {
    name: Scalars['String']['input'];
};

export type TitleIconTypeFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TitleIconTypeHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TitleIconTypeIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type TitleIconTypeUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type TitleIconTypeVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnknownItem = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type UnknownItemChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnknownItemFieldArgs = {
    name: Scalars['String']['input'];
};

export type UnknownItemFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnknownItemHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnknownItemIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type UnknownItemUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type UnknownItemVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Venue = Item &
    _BasePageMeta & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        dressCode?: Maybe<TextField>;
        enquiryHotline?: Maybe<TextField>;
        facilities?: Maybe<TextField>;
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        food?: Maybe<TextField>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        name: Scalars['String']['output'];
        openingHours?: Maybe<TextField>;
        outletLogo?: Maybe<ImageField>;
        pageMetaDescription?: Maybe<TextField>;
        pageMetaImage?: Maybe<ImageField>;
        pageMetaTitle?: Maybe<TextField>;
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        price?: Maybe<TextField>;
        remarks?: Maybe<TextField>;
        template: ItemTemplate;
        titleIconOptions?: Maybe<TextField>;
        url: Scalars['String']['output'];
        venueAccess?: Maybe<TextField>;
        venueDescription?: Maybe<TextField>;
        venueHeroImage?: Maybe<ImageField>;
        venueLink?: Maybe<TextField>;
        venueLinkType?: Maybe<TextField>;
        venueLocation?: Maybe<TextField>;
        venueLocationDetail?: Maybe<TextField>;
        venueLogoImage?: Maybe<ImageField>;
        venueMealType?: Maybe<TextField>;
        venueName?: Maybe<TextField>;
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        workflow: ItemWorkflow;
    };

export type VenueChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueFieldArgs = {
    name: Scalars['String']['input'];
};

export type VenueFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type VenueVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumFolder = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type VenueAlbumFolderChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumFolderFieldArgs = {
    name: Scalars['String']['input'];
};

export type VenueAlbumFolderFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumFolderHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumFolderIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAlbumFolderUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type VenueAlbumFolderVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumMedia = Item &
    MediaItem & {
        access?: Maybe<ItemAccess>;
        children: Array<Maybe<Item>>;
        contentImage?: Maybe<ImageField>;
        database: Scalars['String']['output'];
        displayName: Scalars['String']['output'];
        field?: Maybe<ItemField>;
        fields: Array<Maybe<ItemField>>;
        hasChildren: Scalars['Boolean']['output'];
        icon: Scalars['String']['output'];
        id: Scalars['ID']['output'];
        insertOptions: Array<Maybe<InsertOptions>>;
        itemUri: Scalars['String']['output'];
        language: ItemLanguage;
        mediaCaption?: Maybe<TextField>;
        mediaType?: Maybe<TextField>;
        name: Scalars['String']['output'];
        parent?: Maybe<Item>;
        path: Scalars['String']['output'];
        template: ItemTemplate;
        url: Scalars['String']['output'];
        version: Scalars['Int']['output'];
        versions: Array<Maybe<Item>>;
        videoSrc?: Maybe<TextField>;
        workflow: ItemWorkflow;
    };

export type VenueAlbumMediaChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumMediaFieldArgs = {
    name: Scalars['String']['input'];
};

export type VenueAlbumMediaFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumMediaHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueAlbumMediaIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type VenueAlbumMediaUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type VenueAlbumMediaVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueBlock = Item & {
    access?: Maybe<ItemAccess>;
    blockContent?: Maybe<TextField>;
    blockHeader?: Maybe<TextField>;
    blockSubHeader?: Maybe<TextField>;
    buttonEnable?: Maybe<CheckboxField>;
    buttonLink?: Maybe<TextField>;
    buttonText?: Maybe<TextField>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    displayVenue?: Maybe<MultilistField>;
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    titleIconOptions?: Maybe<TextField>;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    workflow: ItemWorkflow;
};

export type VenueBlockChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueBlockFieldArgs = {
    name: Scalars['String']['input'];
};

export type VenueBlockFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueBlockHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueBlockIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type VenueBlockUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type VenueBlockVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Video = Item & {
    access?: Maybe<ItemAccess>;
    children: Array<Maybe<Item>>;
    database: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    field?: Maybe<ItemField>;
    fields: Array<Maybe<ItemField>>;
    hasChildren: Scalars['Boolean']['output'];
    icon: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    insertOptions: Array<Maybe<InsertOptions>>;
    itemUri: Scalars['String']['output'];
    language: ItemLanguage;
    name: Scalars['String']['output'];
    parent?: Maybe<Item>;
    path: Scalars['String']['output'];
    template: ItemTemplate;
    url: Scalars['String']['output'];
    version: Scalars['Int']['output'];
    versions: Array<Maybe<Item>>;
    videoDescription?: Maybe<TextField>;
    videoSource?: Maybe<TextField>;
    videoThumbnail?: Maybe<ImageField>;
    videoTitle?: Maybe<TextField>;
    workflow: ItemWorkflow;
};

export type VideoChildrenArgs = {
    after?: InputMaybe<Scalars['ID']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoFieldArgs = {
    name: Scalars['String']['input'];
};

export type VideoFieldsArgs = {
    excludeStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
    ownFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoHasChildrenArgs = {
    includeTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    requirePresentation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoIdArgs = {
    format?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUrlArgs = {
    options?: InputMaybe<ItemUrlOptions>;
};

export type VideoVersionsArgs = {
    allLanguages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type _BaseMenu = {
    destination?: Maybe<TextField>;
    displayText?: Maybe<TextField>;
    enabled?: Maybe<CheckboxField>;
    linkTo?: Maybe<TextField>;
};

export type _BasePage = {
    headerBgImage?: Maybe<ImageField>;
    pageDescription?: Maybe<TextField>;
    pageTitle?: Maybe<TextField>;
};

export type _BasePageMeta = {
    pageMetaDescription?: Maybe<TextField>;
    pageMetaImage?: Maybe<ImageField>;
    pageMetaTitle?: Maybe<TextField>;
};

export type HomePartnerFragment = {
    template: { name: string };
    partnerBlockHeader?: { rendered?: string };
    titleIconOptions?: { value?: string };
    partnerList: Array<{
        template: { name: string };
        logoImage?: { src?: string };
        logoLink?: { value?: string };
        clickEventID?: { value?: string };
    }>;
};

export type PartnerBlockQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartnerBlockQueryResult = { Item?: HomePartnerFragment };

export type HomeTestimonialFragment = {
    template: { name: string };
    bgImage?: { src?: string };
    testimonialList: Array<{
        template: { name: string };
        testimonialContent?: { rendered?: string };
        contributor?: { rendered?: string };
    }>;
};

export type TestimonialBlockQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type TestimonialBlockQueryResult = { Item?: HomeTestimonialFragment };

export type HomeThreeFragment = {
    template: { name: string };
    blockATitle?: { value?: string };
    blockAImage?: { src?: string };
    blockAContent?: { rendered?: string };
    blockACtaButtonText?: { value?: string };
    blockACtaButtonLink?: { value?: string };
    blockBTitle?: { value?: string };
    blockBImage?: { src?: string };
    blockBContent?: { rendered?: string };
    blockBCtaButtonText?: { value?: string };
    blockBCtaButtonLink?: { value?: string };
    blockCTitle?: { value?: string };
    blockCImage?: { src?: string };
    blockCContent?: { rendered?: string };
    blockCCtaButtonText?: { value?: string };
    blockCCtaButtonLink?: { value?: string };
};

export type ThreeBlocksQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type ThreeBlocksQueryResult = { Item?: HomeThreeFragment };

export type HomepageContentSliderFragment = {
    template: { name: string };
    pageContentSliderList: Array<{
        template: { name: string };
        layoutType?: { value?: string };
        titleIconOptions?: { value?: string };
        contentImage?: { src?: string };
        contentImageLink?: { value?: string };
        contentImageLinkEnable?: { boolValue?: boolean };
        contentSubHeader?: { value?: string };
        contentHeader?: { rendered?: string };
        contentText?: { rendered?: string };
        contentCtaEnable?: { boolValue?: boolean };
        contentCtaText?: { value?: string };
        contentCtaLink?: { value?: string };
    }>;
};

export type HomepageContentSliderQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type HomepageContentSliderQueryResult = { Item?: HomepageContentSliderFragment };

export type HomeInstagramFragment = {
    template: { name: string };
    igBlockHeader?: { value?: string };
    igBlockContent?: { rendered?: string };
    igBlockBgImage?: { src?: string };
    titleIconOptions?: { value?: string };
    instagramList: Array<{
        template: { name: string };
        igPostTitle?: { value?: string };
        igPostContent?: { rendered?: string };
        igPostImage?: { src?: string };
        igPostLink?: { value?: string };
    }>;
};

export type HomepageIgContainerQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type HomepageIgContainerQueryResult = { Item?: HomeInstagramFragment };

export type InMenuItemFragment = {
    name: string;
    linkTo?: { value?: string };
    displayText?: { value?: string };
    destination?: { value?: string };
    enabled?: { boolValue?: boolean };
    headerMenu?: { boolValue?: boolean };
    footerMenu?: { boolValue?: boolean };
};

export type InSiteNavigationQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type InSiteNavigationQueryResult = {
    inSiteNavigation?:
        | { name: string; children: Array<InMenuItemFragment> }
        | { name: string; children: Array<InMenuItemFragment> }
        | { name: string; children: Array<InMenuItemFragment> }
        | { name: string; children: Array<InMenuItemFragment> };
};

export type SeoAlbumDetailFragment = {
    name: string;
    id: string;
    pageMetaTitle?: { value?: string };
    pageMetaDescription?: { value?: string };
    pageMetaImage?: { src?: string };
};

export type SeoAlbumDetailQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type SeoAlbumDetailQueryResult = { SEOAlbumDetailItem?: SeoAlbumDetailFragment };

export type SeoFragment = {
    name: string;
    id: string;
    pageMetaTitle?: { value?: string };
    pageMetaDescription?: { value?: string };
    pageMetaImage?: { src?: string };
};

export type SeoQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type SeoQueryResult = { SEOItem?: SeoFragment };

export type SeoPartyDetailFragment = {
    name: string;
    id: string;
    pageMetaTitle?: { value?: string };
    pageMetaDescription?: { value?: string };
    pageMetaImage?: { src?: string };
};

export type SeoPartyDetailQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type SeoPartyDetailQueryResult = { SEOPartyDetailItem?: SeoPartyDetailFragment };

export type AlertPopupFragment = {
    name: string;
    alertEnable?: { boolValue?: boolean };
    alertStartDate?: { dateValue?: number };
    alertEndDate?: { dateValue?: number };
    alertHeader?: { value?: string };
    alertContent?: { rendered?: string };
    alertCtaButtonText?: { value?: string };
    alertCtaButtonLink?: { value?: string };
    alertCtaButtonEnabled?: { boolValue?: boolean };
};

export type AlertPopupsQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type AlertPopupsQueryResult = {
    Item?:
        | { alertList: Array<AlertPopupFragment> }
        | { alertList: Array<AlertPopupFragment> }
        | { alertList: Array<AlertPopupFragment> }
        | { alertList: Array<AlertPopupFragment> };
};

export type CrossSellBannerFragment = {
    id: string;
    name: string;
    path: string;
    template: { name: string };
    bannerType?: { value?: string };
    bannerBgImage?: { src?: string };
    titleIconOptions?: { value?: string };
    generalHeader?: { value?: string };
    generalContent?: { rendered?: string };
    generalCtaEnable?: { boolValue?: boolean };
    generalCtaText?: { value?: string };
    generalCtaLink?: { value?: string };
    partyLink?: {
        targetItem?:
            | { name: string }
            | { name: string }
            | { name: string }
            | { name: string }
            | { name: string; partyName?: { value?: string }; partyDateText?: { value?: string } };
    };
    partyCtaEnable?: { boolValue?: boolean };
    partyCtaLink?: { value?: string };
};

export type CrossSellBannerQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type CrossSellBannerQueryResult = { Item?: CrossSellBannerFragment };

export type PageRowDomFragment = {
    name: string;
    desktopColumnStyle?: { value?: string };
    mobileColumnStyle?: { value?: string };
    col: Array<
        | {
              pageContent: Array<
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
              >;
          }
        | {
              pageContent: Array<
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
              >;
          }
        | {
              pageContent: Array<
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
              >;
          }
        | {
              pageContent: Array<
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
                  | { path: string; template: { name: string } }
              >;
          }
    >;
};

export type PageFragment = {
    name: string;
    id: string;
    pageMetaTitle?: { value?: string };
    pageMetaDescription?: { value?: string };
    pageMetaImage?: { src?: string };
    pageTitle?: { value?: string };
    pageDescription?: { rendered?: string };
    headerBgImage?: { src?: string };
};

export type GeneralPageQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type GeneralPageQueryResult = {
    generalPage?:
        | { row: Array<PageRowDomFragment> }
        | { row: Array<PageRowDomFragment> }
        | { row: Array<PageRowDomFragment> }
        | { row: Array<PageRowDomFragment> }
        | ({ row: Array<PageRowDomFragment> } & PageFragment);
};

export type GlobalSettingsFragment = {
    hKJCLogo?: { src?: string };
    mobileHKJCLogo?: { src?: string };
    ewinLogo?: { src?: string };
    masterColorCode?: { targetItem?: ColorCodeFragment };
    hwHeaderLogo?: { src?: string };
    headerCTAButtonText?: { value?: string };
    headerCTAButtonLink?: { value?: string };
    headerCTAButtonEnable?: { boolValue?: boolean };
    hwFooterLogo?: { src?: string };
    rgpContent?: { rendered?: string };
    redirectPopupTitle?: { value?: string };
    redirectPopupContent?: { rendered?: string };
    redirectButtonText?: { value?: string };
    defaultMetaTitleSuffix?: { value?: string };
    defaultMetaTitle?: { value?: string };
    defaultMetaDescription?: { value?: string };
    defaultMetaImage?: { src?: string };
};

export type ColorCodeFragment = {
    themeColorCode?: { value?: string };
    fontColor?: { value?: string };
    overlayBGColor?: { value?: string };
    musicWaveColor?: { value?: string };
    buttonBGColor?: { value?: string };
    primaryButtonBGColor?: { value?: string };
    primaryButtonIconColor?: { value?: string };
    secondaryButtonBGColor?: { value?: string };
    secondaryButtonIconColor?: { value?: string };
    highlightColor?: { value?: string };
    h2Color?: { value?: string };
};

export type GlobalSettingQueryVariables = Exact<{
    lang: Scalars['String']['input'];
}>;

export type GlobalSettingQueryResult = { globalSettings?: GlobalSettingsFragment };

export type HomePageHeroFragment = {
    path: string;
    template: { name: string };
    enable?: { boolValue?: boolean };
    heroTitle?: { rendered?: string };
    heroBackground?: { src?: string };
    heroMobileBackground?: { src?: string };
    heroBackgroundLink?: { value?: string };
    ctaEnable?: { boolValue?: boolean };
    ctaText?: { value?: string };
    ctaIcon?: { value?: string };
    ctaLink?: { value?: string };
    videoEnable?: { boolValue?: boolean };
    videoSrc?: { value?: string };
    backgroundVideoSrc?: { value?: string };
    videoPoster?: { src?: string };
    cardTitle?: { value?: string };
    cardCategory?: { value?: string };
    cardDuration?: { value?: string };
};

export type HomepageHeroBlockQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type HomepageHeroBlockQueryResult = {
    Item?:
        | { template: { name: string }; list: Array<HomePageHeroFragment> }
        | { template: { name: string }; list: Array<HomePageHeroFragment> }
        | { template: { name: string }; list: Array<HomePageHeroFragment> }
        | { template: { name: string }; list: Array<HomePageHeroFragment> };
};

export type HomePartyPromotionFragment = {
    template: { name: string };
    title?: { value?: string };
    titleIconOptions?: { value?: string };
    parties?: { targetItems?: Array<PartyInformationFragment> };
};

export type PartyInfoBlockQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartyInfoBlockQueryResult = { Item?: HomePartyPromotionFragment };

export type InLineBusTableDataFragment = {
    combineFromAndTo?: { boolValue?: boolean };
    routeNo?: { value?: string };
    from?: { value?: string };
    to?: { value?: string };
    operators?: { value?: string };
};

export type InLineBusModalFragment = {
    title?: { value?: string };
    subTitle?: { value?: string };
    remark?: { value?: string };
    tableData: Array<InLineBusTableDataFragment>;
};

export type InLineBusModalQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type InLineBusModalQueryResult = {
    content?:
        | {
              children: Array<
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | ({ name: string } & InLineBusModalFragment)
              >;
          }
        | {
              children: Array<
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | ({ name: string } & InLineBusModalFragment)
              >;
          }
        | {
              children: Array<
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | ({ name: string } & InLineBusModalFragment)
              >;
          }
        | {
              children: Array<
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | { name: string }
                  | ({ name: string } & InLineBusModalFragment)
              >;
          };
};

export type PageAccordionFragment = {
    name: string;
    path: string;
    template: { name: string };
    accordionContainerHeader?: { rendered?: string };
    accordionContainerContent?: { rendered?: string };
    accordionContainerDefaultActiveKey?: { value?: string };
    accordionRows: Array<AccordionRowFragment>;
    titleIconOptions?: { value?: string };
};

export type AccordionRowFragment = {
    name: string;
    template: { name: string };
    accordionRowHeader?: { rendered?: string };
    accordionRowContent?: { rendered?: string };
};

export type AccordionContainerQueryVariables = Exact<{
    path: Scalars['String']['input'];
    lang: Scalars['String']['input'];
}>;

export type AccordionContainerQueryResult = { Item?: PageAccordionFragment };

export type PageAlbumFragment = {
    name: string;
    path: string;
    template: { name: string };
    layoutBlock?: { value?: string };
    albumList: Array<AlbumItemFragment>;
};

export type AlbumItemFragment = {
    name: string;
    template: { name: string };
    mediaType?: { value?: string };
    contentImage?: { src?: string };
    videoSrc?: { value?: string };
    mediaCaption?: { value?: string };
};

export type PartyAlbumBlockQueryVariables = Exact<{
    path: Scalars['String']['input'];
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartyAlbumBlockQueryResult = { Item?: PageAlbumFragment };

export type PageDiningSingleBlockFragment = {
    name: string;
    path: string;
    template: { name: string };
    venueLink?: { targetItem?: VenueItemFragment };
    blockLayout?: { value?: string };
    subHeaderTitle?: { rendered?: string };
    diningDescription?: { rendered?: string };
    buttonType?: { value?: string };
    buttonText?: { value?: string };
    buttonLink?: { value?: string };
    titleIconOptions?: { value?: string };
};

export type DiningSingleBlockQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type DiningSingleBlockQueryResult = { Item?: PageDiningSingleBlockFragment };

export type PageImageFragment = {
    name: string;
    path: string;
    template: { name: string };
    imageSelection?: { src?: string };
    imageCaption?: { value?: string };
    imageLightboxEnable?: { boolValue?: boolean };
};

export type ImageQueryVariables = Exact<{
    path: Scalars['String']['input'];
    lang: Scalars['String']['input'];
}>;

export type ImageQueryResult = { Item?: PageImageFragment };

export type PageOtherDiningFragment = {
    name: string;
    path: string;
    template: { name: string };
    diningOptions?: { otherDiningList?: Array<VenueItemFragment> };
    sectionTitle?: { rendered?: string };
    titleIconOptions?: { value?: string };
    buttonText?: { value?: string };
    buttonLink?: { value?: string };
};

export type OtherDiningOptionsQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type OtherDiningOptionsQueryResult = { Item?: PageOtherDiningFragment };

export type DateListFragment = {
    name: string;
    mediaType?: { value?: string };
    contentImage?: { src?: string };
    videoSrc?: { value?: string };
    mediaCaption?: { value?: string };
};

export type PartyInfoFragment = {
    partyName?: { value?: string };
    albumList: Array<
        | {
              name: string;
              photoList: Array<
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | {
                        name: string;
                        albumDate?: { value?: string };
                        albumImage?: { src?: string };
                        albumCaption?: { value?: string };
                        enabled?: { boolValue?: boolean };
                        dateList: Array<DateListFragment>;
                    }
                  | ({ name: string; dateList: Array<DateListFragment> } & PhotoAlbumBulkFragment)
              >;
          }
        | {
              name: string;
              photoList: Array<
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | {
                        name: string;
                        albumDate?: { value?: string };
                        albumImage?: { src?: string };
                        albumCaption?: { value?: string };
                        enabled?: { boolValue?: boolean };
                        dateList: Array<DateListFragment>;
                    }
                  | ({ name: string; dateList: Array<DateListFragment> } & PhotoAlbumBulkFragment)
              >;
          }
        | {
              name: string;
              photoList: Array<
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | {
                        name: string;
                        albumDate?: { value?: string };
                        albumImage?: { src?: string };
                        albumCaption?: { value?: string };
                        enabled?: { boolValue?: boolean };
                        dateList: Array<DateListFragment>;
                    }
                  | ({ name: string; dateList: Array<DateListFragment> } & PhotoAlbumBulkFragment)
              >;
          }
        | {
              name: string;
              photoList: Array<
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | { name: string; dateList: Array<DateListFragment> }
                  | {
                        name: string;
                        albumDate?: { value?: string };
                        albumImage?: { src?: string };
                        albumCaption?: { value?: string };
                        enabled?: { boolValue?: boolean };
                        dateList: Array<DateListFragment>;
                    }
                  | ({ name: string; dateList: Array<DateListFragment> } & PhotoAlbumBulkFragment)
              >;
          }
    >;
};

export type PartiesFragment = {
    partyList?: Array<
        | { id: string; name: string }
        | { id: string; name: string }
        | { id: string; name: string }
        | { id: string; name: string }
        | ({ id: string; name: string } & PartyInfoFragment)
    >;
};

export type PagePhotoAlbumBlockFragment = {
    name: string;
    template: { name: string };
    parties?: PartiesFragment;
};

export type PhotoAlbumBlockQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PhotoAlbumBlockQueryResult = {
    Item?:
        | {
              row: Array<
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
              >;
          }
        | {
              row: Array<
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
              >;
          }
        | {
              row: Array<
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
              >;
          }
        | {
              row: Array<
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
              >;
          }
        | ({
              row: Array<
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
                  | {
                        name: string;
                        col: Array<
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                            | {
                                  pageContent: Array<
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | { path: string; template: { name: string } }
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & CrossSellBannerFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PagePhotoAlbumBlockFragment)
                                      | ({
                                            path: string;
                                            template: { name: string };
                                        } & PageRowFragment)
                                  >;
                              }
                        >;
                    }
              >;
          } & PageFragment);
};

export type PhotoAlbumBulkFragment = {
    albumDate?: { value?: string };
    albumImage?: { src?: string };
    albumCaption?: { value?: string };
    enabled?: { boolValue?: boolean };
    albumSelection?: {
        targetItems?: Array<{ url: string } | { url: string } | { url: string } | { url: string }>;
    };
};

export type PhotoAlbumBulkQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PhotoAlbumBulkQueryResult = {
    Item?:
        | { path: string; template: { name: string } }
        | { path: string; template: { name: string } }
        | { path: string; template: { name: string } }
        | { path: string; template: { name: string } }
        | ({ path: string; template: { name: string } } & PhotoAlbumBulkFragment);
};

export type PageRowFragment = {
    name: string;
    path: string;
    template: { name: string };
    rowHeader?: { rendered?: string };
    rowContent?: { rendered?: string };
    titleIconOptions?: { value?: string };
    rowLayout?: { value?: string };
    buttonAText?: { value?: string };
    buttonALink?: { value?: string };
    buttonAEnable?: { boolValue?: boolean };
    buttonBText?: { value?: string };
    buttonBLink?: { value?: string };
    buttonBEnable?: { boolValue?: boolean };
};

export type RowQueryVariables = Exact<{
    path: Scalars['String']['input'];
    lang: Scalars['String']['input'];
}>;

export type RowQueryResult = { Item?: PageRowFragment };

export type VenueAlbumFragment = {
    name: string;
    mediaType?: { value?: string };
    contentImage?: { src?: string };
    videoSrc?: { value?: string };
    mediaCaption?: { value?: string };
};

export type PageVenueFragment = {
    name: string;
    template: { name: string };
    blockSubHeader?: { value?: string };
    blockHeader?: { value?: string };
    blockContent?: { rendered?: string };
    buttonText?: { value?: string };
    buttonLink?: { value?: string };
    buttonEnable?: { boolValue?: boolean };
    titleIconOptions?: { value?: string };
    displayVenue?: VenueMultilistFragment;
};

export type VenueMultilistFragment = { name: string; venueList?: Array<VenueItemFragment> };

export type VenueItemFragment = {
    template: { name: string };
    venueName?: { value?: string };
    venueDescription?: { rendered?: string };
    venueHeroImage?: { src?: string };
    venueLogoImage?: { src?: string };
    venueLocation?: { rendered?: string };
    venueLocationDetail?: { rendered?: string };
    venueAccess?: { value?: string };
    openingHours?: { value?: string };
    enquiryHotline?: { value?: string };
    food?: { value?: string };
    price?: { rendered?: string };
    dressCode?: { value?: string };
    facilities?: { value?: string };
    remarks?: { rendered?: string };
    venueMealType?: { value?: string };
    venueAlbums: Array<{
        name: string;
        template: { name: string };
        albumList: Array<VenueAlbumFragment>;
    }>;
    venueLinkType?: { value?: string };
    venueLink?: { value?: string };
    titleIconOptions?: { value?: string };
    outletLogo?: { src?: string };
};

export type PageVenueQueryVariables = Exact<{
    path: Scalars['String']['input'];
    lang: Scalars['String']['input'];
}>;

export type PageVenueQueryResult = { Item?: PageVenueFragment };

export type PartyIdFragment = {
    name: string;
    template: { name: string };
    parties?: { targetItems?: Array<PartyInformationFragment> };
    titleIconOptions?: { value?: string };
};

export type PartiesPageQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartiesPageQueryResult = {
    partiesPage?:
        | {
              id: string;
              row: Array<
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
              >;
          }
        | {
              id: string;
              row: Array<
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
              >;
          }
        | {
              id: string;
              row: Array<
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
              >;
          }
        | {
              id: string;
              row: Array<
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
              >;
          }
        | ({
              id: string;
              row: Array<
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
                  | {
                        col: Array<
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                            | { pageContent: Array<CrossSellBannerFragment | PartyIdFragment> }
                        >;
                    }
              >;
          } & PageFragment);
};

export type PartyDateFolderFragment = {
    template: { name: string };
    partyCardList: Array<PartyCardListFragment>;
};

export type PartyCardListFragment = {
    name: string;
    partyCardState?: {
        targetItem?: { name: string } | { name: string } | { name: string } | { name: string };
    };
    albumPath?: {
        targetItem?: { path: string } | { path: string } | { path: string } | { path: string };
    };
    partyDateTime?: { dateValue?: number };
    partyEndDateTime?: { dateValue?: number };
    partyCardTitle?: { value?: string };
    partyCardText?: { value?: string };
    partyCardImage?: { src?: string };
    partyCardItem: Array<PartyCardItemFragment>;
};

export type PartyCardItemFragment = {
    iconImage?: {
        targetItem?: { name: string } | { name: string } | { name: string } | { name: string };
    };
    rowTitle?: { value?: string };
    rowContent?: { value?: string };
};

export type PartyDateFolderQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartyDateFolderQueryResult = { partyDateFolder?: PartyDateFolderFragment };

export type PartyDetailFragment = {
    name: string;
    pageTitle?: { value?: string };
    pageDescription?: { rendered?: string };
    headerBgImage?: { src?: string };
    row: Array<
        | {
              name: string;
              col: Array<
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
              >;
          }
        | {
              name: string;
              col: Array<
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
              >;
          }
        | {
              name: string;
              col: Array<
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
              >;
          }
        | {
              name: string;
              col: Array<
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
                  | {
                        name: string;
                        pageContent: Array<
                            | CrossSellBannerFragment
                            | PageImageFragment
                            | PageAlbumFragment
                            | PartCardBlockFragment
                            | PartIntroBlockFragment
                            | PageRowFragment
                            | PageVenueFragment
                        >;
                    }
              >;
          }
    >;
};

export type PartIntroBlockFragment = {
    template: { name: string };
    partyIntroTitle?: { value?: string };
    partyIntroContent?: { rendered?: string };
};

export type PartCardBlockFragment = { template: { name: string } };

export type PartyDetailQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartyDetailQueryResult = { partyDetail?: PartyDetailFragment };

export type PartyInformationFragment = {
    id: string;
    name: string;
    template: { name: string };
    partyName?: { value?: string };
    partyDescription?: { rendered?: string };
    partyImage?: { src?: string };
    partyColorCode?: { targetItem?: ColorCodeFragment };
    partyDateText?: { value?: string };
    startDatetime?: { dateValue?: number };
    endDatetime?: { dateValue?: number };
    ctaButtonText?: { value?: string };
    ctaButtonUrl?: { value?: string };
    homeCardCTAButtonText?: { value?: string };
    homeCardCTAButtonUrl?: { value?: string };
    partyDates: Array<
        | { dateList: Array<PartyCardListFragment> }
        | { dateList: Array<PartyCardListFragment> }
        | { dateList: Array<PartyCardListFragment> }
        | { dateList: Array<PartyCardListFragment> }
    >;
};

export type PartyInformationQueryVariables = Exact<{
    path?: InputMaybe<Scalars['String']['input']>;
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartyInformationQueryResult = {
    partyInformation?:
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | ({ id: string } & PageFragment)
        | ({ id: string } & PartyInformationFragment);
};

export type SubMenuItemFragment = {
    name: string;
    displayText?: { value?: string };
    destination?: { value?: string };
    linkTo?: { value?: string };
    enabled?: { boolValue?: boolean };
};

export type MenuFragment = {
    name: string;
    displayText?: { value?: string };
    destination?: { value?: string };
    linkTo?: { value?: string };
    enabled?: { boolValue?: boolean };
};

export type MenuItemFragment = { children: Array<SubMenuItemFragment> } & MenuFragment;

export type SiteNavigationQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type SiteNavigationQueryResult = {
    siteNavigation?:
        | {
              children: Array<
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
              >;
          }
        | {
              children: Array<
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
              >;
          }
        | {
              children: Array<
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
              >;
          }
        | {
              children: Array<
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
                  | { name: string; children: Array<MenuItemFragment> }
              >;
          };
};

export type SocialMediaIconFragment = {
    name: string;
    socialName?: { value?: string };
    socialLink?: { value?: string };
    socialIcon?: { src?: string };
};

export type SocialMediaIconQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type SocialMediaIconQueryResult = {
    socialMediaIcon?:
        | { iocnList: Array<SocialMediaIconFragment> }
        | { iocnList: Array<SocialMediaIconFragment> }
        | { iocnList: Array<SocialMediaIconFragment> }
        | { iocnList: Array<SocialMediaIconFragment> };
};

export type WhitelistQueryVariables = Exact<{
    lang?: InputMaybe<Scalars['String']['input']>;
}>;

export type WhitelistQueryResult = {
    routes?:
        | {
              children: Array<
                  { name: string } | { name: string } | { name: string } | { name: string }
              >;
          }
        | {
              children: Array<
                  { name: string } | { name: string } | { name: string } | { name: string }
              >;
          }
        | {
              children: Array<
                  { name: string } | { name: string } | { name: string } | { name: string }
              >;
          }
        | {
              children: Array<
                  { name: string } | { name: string } | { name: string } | { name: string }
              >;
          };
};

export const HomePartnerFragmentDoc = gql`
    fragment HomePartnerFragment on PartnerBlock {
        template {
            name
        }
        partnerBlockHeader {
            rendered
        }
        titleIconOptions {
            value
        }
        partnerList: children {
            ... on PartnerLogo {
                template {
                    name
                }
                logoImage {
                    ... on ImageField {
                        src(maxWidth: null)
                    }
                }
                logoLink {
                    value
                }
                clickEventID {
                    value
                }
            }
        }
    }
`;
export const HomeTestimonialFragmentDoc = gql`
    fragment HomeTestimonialFragment on TestimonialBlock {
        template {
            name
        }
        bgImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        testimonialList: children {
            ... on Testimonial {
                template {
                    name
                }
                testimonialContent {
                    rendered
                }
                contributor {
                    rendered
                }
            }
        }
    }
`;
export const HomeThreeFragmentDoc = gql`
    fragment HomeThreeFragment on ThreeBlocks {
        template {
            name
        }
        blockATitle {
            value
        }
        blockAImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        blockAContent {
            rendered
        }
        blockACtaButtonText {
            value
        }
        blockACtaButtonLink {
            value
        }
        blockBTitle {
            value
        }
        blockBImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        blockBContent {
            rendered
        }
        blockBCtaButtonText {
            value
        }
        blockBCtaButtonLink {
            value
        }
        blockCTitle {
            value
        }
        blockCImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        blockCContent {
            rendered
        }
        blockCCtaButtonText {
            value
        }
        blockCCtaButtonLink {
            value
        }
    }
`;
export const HomepageContentSliderFragmentDoc = gql`
    fragment HomepageContentSliderFragment on HomepageContentSlider {
        template {
            name
        }
        pageContentSliderList: children {
            ... on HomepageContentSlide {
                template {
                    name
                }
                layoutType {
                    value
                }
                titleIconOptions {
                    value
                }
                contentImage {
                    ... on ImageField {
                        src(maxWidth: null)
                    }
                }
                contentImageLink {
                    value
                }
                contentImageLinkEnable {
                    boolValue
                }
                contentSubHeader {
                    value
                }
                contentHeader {
                    rendered
                }
                contentText {
                    rendered
                }
                contentCtaEnable {
                    boolValue
                }
                contentCtaText {
                    value
                }
                contentCtaLink {
                    value
                }
            }
        }
    }
`;
export const HomeInstagramFragmentDoc = gql`
    fragment HomeInstagramFragment on HomepageIgContainer {
        template {
            name
        }
        igBlockHeader {
            value
        }
        igBlockContent {
            rendered
        }
        igBlockBgImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        titleIconOptions {
            value
        }
        instagramList: children {
            ... on HomepageIgPost {
                template {
                    name
                }
                igPostTitle {
                    value
                }
                igPostContent {
                    rendered
                }
                igPostImage {
                    ... on ImageField {
                        src(maxWidth: null)
                    }
                }
                igPostLink {
                    value
                }
            }
        }
    }
`;
export const InMenuItemFragmentDoc = gql`
    fragment INMenuItemFragment on HeaderMenu {
        name
        linkTo {
            value
        }
        displayText {
            value
        }
        destination {
            value
        }
        enabled {
            boolValue
        }
        headerMenu {
            boolValue
        }
        footerMenu {
            boolValue
        }
    }
`;
export const SeoAlbumDetailFragmentDoc = gql`
    fragment SEOAlbumDetailFragment on Party {
        name
        id
        pageMetaTitle {
            value
        }
        pageMetaDescription {
            value
        }
        pageMetaImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
    }
`;
export const SeoFragmentDoc = gql`
    fragment SEOFragment on GeneralPageItem {
        name
        id
        pageMetaTitle {
            value
        }
        pageMetaDescription {
            value
        }
        pageMetaImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
    }
`;
export const SeoPartyDetailFragmentDoc = gql`
    fragment SEOPartyDetailFragment on PartyDetailPageItem {
        name
        id
        pageMetaTitle {
            value
        }
        pageMetaDescription {
            value
        }
        pageMetaImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
    }
`;
export const AlertPopupFragmentDoc = gql`
    fragment AlertPopupFragment on AlertPopupMessage {
        name
        alertEnable {
            boolValue
        }
        alertStartDate {
            dateValue
        }
        alertEndDate {
            dateValue
        }
        alertHeader {
            value
        }
        alertContent {
            rendered
        }
        alertCtaButtonText {
            value
        }
        alertCtaButtonLink {
            value
        }
        alertCtaButtonEnabled {
            boolValue
        }
    }
`;
export const PageRowDomFragmentDoc = gql`
    fragment PageRowDomFragment on PageRow {
        name
        desktopColumnStyle {
            value
        }
        mobileColumnStyle {
            value
        }
        col: children {
            pageContent: children {
                path
                template {
                    name
                }
            }
        }
    }
`;
export const PageFragmentDoc = gql`
    fragment PageFragment on GeneralPageItem {
        name
        id
        pageMetaTitle {
            value
        }
        pageMetaDescription {
            value
        }
        pageMetaImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        pageTitle {
            value
        }
        pageDescription {
            rendered
        }
        headerBgImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
    }
`;
export const ColorCodeFragmentDoc = gql`
    fragment ColorCodeFragment on ColorCode {
        themeColorCode {
            value
        }
        fontColor {
            value
        }
        overlayBGColor {
            value
        }
        musicWaveColor {
            value
        }
        buttonBGColor {
            value
        }
        primaryButtonBGColor {
            value
        }
        primaryButtonIconColor {
            value
        }
        secondaryButtonBGColor {
            value
        }
        secondaryButtonIconColor {
            value
        }
        highlightColor {
            value
        }
        h2Color {
            value
        }
    }
`;
export const GlobalSettingsFragmentDoc = gql`
    fragment GlobalSettingsFragment on SiteGlobalConfiguration {
        hKJCLogo {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        mobileHKJCLogo {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        ewinLogo {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        masterColorCode {
            targetItem {
                ...ColorCodeFragment
            }
        }
        hwHeaderLogo {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        headerCTAButtonText {
            value
        }
        headerCTAButtonLink {
            value
        }
        headerCTAButtonEnable {
            boolValue
        }
        hwFooterLogo {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        rgpContent {
            rendered
        }
        redirectPopupTitle {
            value
        }
        redirectPopupContent {
            rendered
        }
        redirectButtonText {
            value
        }
        defaultMetaTitleSuffix {
            value
        }
        defaultMetaTitle {
            value
        }
        defaultMetaDescription {
            value
        }
        defaultMetaImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
    }
    ${ColorCodeFragmentDoc}
`;
export const HomePageHeroFragmentDoc = gql`
    fragment HomePageHeroFragment on HomepageHeroItem {
        template {
            name
        }
        path
        enable {
            boolValue
        }
        heroTitle {
            rendered
        }
        heroBackground {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        heroMobileBackground {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        heroBackgroundLink {
            value
        }
        ctaEnable {
            boolValue
        }
        ctaText {
            value
        }
        ctaIcon {
            value
        }
        ctaLink {
            value
        }
        videoEnable {
            boolValue
        }
        videoSrc {
            value
        }
        backgroundVideoSrc {
            value
        }
        videoPoster {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        cardTitle {
            value
        }
        cardCategory {
            value
        }
        cardDuration {
            value
        }
    }
`;
export const PartyCardItemFragmentDoc = gql`
    fragment PartyCardItemFragment on PartyCardRow {
        iconImage {
            targetItem {
                name
            }
        }
        rowTitle {
            value
        }
        rowContent {
            value
        }
    }
`;
export const PartyCardListFragmentDoc = gql`
    fragment PartyCardListFragment on PartyDate {
        name
        partyCardState {
            targetItem {
                name
            }
        }
        albumPath {
            targetItem {
                path
            }
        }
        partyDateTime {
            dateValue
        }
        partyEndDateTime {
            dateValue
        }
        partyCardTitle {
            value
        }
        partyCardText {
            value
        }
        partyCardImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        partyCardItem: children {
            ...PartyCardItemFragment
        }
    }
    ${PartyCardItemFragmentDoc}
`;
export const PartyInformationFragmentDoc = gql`
    fragment PartyInformationFragment on Party {
        id
        name
        template {
            name
        }
        partyName {
            value
        }
        partyDescription {
            rendered
        }
        partyImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        partyColorCode {
            targetItem {
                ...ColorCodeFragment
            }
        }
        partyDateText {
            value
        }
        startDatetime {
            dateValue
        }
        endDatetime {
            dateValue
        }
        ctaButtonText {
            value
        }
        ctaButtonUrl {
            value
        }
        homeCardCTAButtonText {
            value
        }
        homeCardCTAButtonUrl {
            value
        }
        partyDates: children(includeTemplateIDs: "205369F0-7B77-4891-A749-C27DD8D67EDC") {
            dateList: children {
                ...PartyCardListFragment
            }
        }
    }
    ${ColorCodeFragmentDoc}
    ${PartyCardListFragmentDoc}
`;
export const HomePartyPromotionFragmentDoc = gql`
    fragment HomePartyPromotionFragment on PartyInfoBlock {
        template {
            name
        }
        title {
            value
        }
        titleIconOptions {
            value
        }
        parties {
            targetItems {
                ... on Party {
                    ...PartyInformationFragment
                }
            }
        }
    }
    ${PartyInformationFragmentDoc}
`;
export const InLineBusTableDataFragmentDoc = gql`
    fragment InLineBusTableDataFragment on InLineBusTableRow {
        combineFromAndTo {
            boolValue
        }
        routeNo {
            value
        }
        from {
            value
        }
        to {
            value
        }
        operators {
            value
        }
    }
`;
export const InLineBusModalFragmentDoc = gql`
    fragment InLineBusModalFragment on InLineBusModal {
        title {
            value
        }
        subTitle {
            value
        }
        remark {
            value
        }
        tableData: children {
            ...InLineBusTableDataFragment
        }
    }
    ${InLineBusTableDataFragmentDoc}
`;
export const AccordionRowFragmentDoc = gql`
    fragment AccordionRowFragment on AccordionRow {
        name
        template {
            name
        }
        accordionRowHeader {
            rendered
        }
        accordionRowContent {
            rendered
        }
    }
`;
export const PageAccordionFragmentDoc = gql`
    fragment PageAccordionFragment on AccordionContainer {
        name
        path
        template {
            name
        }
        accordionContainerHeader {
            rendered
        }
        accordionContainerContent {
            rendered
        }
        accordionContainerDefaultActiveKey {
            value
        }
        accordionRows: children {
            ...AccordionRowFragment
        }
        titleIconOptions {
            value
        }
    }
    ${AccordionRowFragmentDoc}
`;
export const VenueAlbumFragmentDoc = gql`
    fragment VenueAlbumFragment on VenueAlbumMedia {
        name
        mediaType {
            value
        }
        contentImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        videoSrc {
            value
        }
        mediaCaption {
            value
        }
    }
`;
export const VenueItemFragmentDoc = gql`
    fragment VenueItemFragment on Venue {
        template {
            name
        }
        venueName {
            value
        }
        venueDescription {
            rendered
        }
        venueHeroImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        venueLogoImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        venueLocation {
            rendered
        }
        venueLocationDetail {
            rendered
        }
        venueAccess {
            value
        }
        openingHours {
            value
        }
        enquiryHotline {
            value
        }
        food {
            value
        }
        price {
            rendered
        }
        dressCode {
            value
        }
        facilities {
            value
        }
        remarks {
            rendered
        }
        venueMealType {
            value
        }
        venueAlbums: children {
            ... on VenueAlbumFolder {
                name
                template {
                    name
                }
                albumList: children {
                    ...VenueAlbumFragment
                }
            }
        }
        venueLinkType {
            value
        }
        venueLink {
            value
        }
        titleIconOptions {
            value
        }
        outletLogo {
            src
        }
    }
    ${VenueAlbumFragmentDoc}
`;
export const PageDiningSingleBlockFragmentDoc = gql`
    fragment PageDiningSingleBlockFragment on DiningSingleBlock {
        name
        path
        template {
            name
        }
        venueLink {
            targetItem {
                ...VenueItemFragment
            }
        }
        blockLayout {
            value
        }
        subHeaderTitle {
            rendered
        }
        diningDescription {
            rendered
        }
        buttonType {
            value
        }
        buttonText {
            value
        }
        buttonLink {
            value
        }
        titleIconOptions {
            value
        }
    }
    ${VenueItemFragmentDoc}
`;
export const PageOtherDiningFragmentDoc = gql`
    fragment PageOtherDiningFragment on OtherDiningOptions {
        name
        path
        template {
            name
        }
        diningOptions {
            otherDiningList: targetItems {
                ...VenueItemFragment
            }
        }
        sectionTitle {
            rendered
        }
        titleIconOptions {
            value
        }
        buttonText {
            value
        }
        buttonLink {
            value
        }
    }
    ${VenueItemFragmentDoc}
`;
export const PhotoAlbumBulkFragmentDoc = gql`
    fragment PhotoAlbumBulkFragment on PhotoAlbumBulk {
        albumDate {
            value
        }
        albumImage {
            src
        }
        albumCaption {
            value
        }
        enabled {
            boolValue
        }
        albumSelection {
            targetItems {
                ... on Item {
                    url
                }
            }
        }
    }
`;
export const DateListFragmentDoc = gql`
    fragment DateListFragment on PhotoAlbumMedia {
        name
        mediaType {
            value
        }
        contentImage {
            src
        }
        videoSrc {
            value
        }
        mediaCaption {
            value
        }
    }
`;
export const PartyInfoFragmentDoc = gql`
    fragment PartyInfoFragment on Party {
        partyName {
            value
        }
        albumList: children(
            includeTemplateIDs: [
                "A87A00B1-E6DB-45AB-8B54-636FEC3B5523"
                "3841F549-B478-407E-9941-72A67C3B01B2"
            ]
        ) {
            ... on Item {
                name
                photoList: children {
                    ... on Item {
                        name
                        ... on PhotoAlbum {
                            albumDate {
                                value
                            }
                            albumImage {
                                src
                            }
                            albumCaption {
                                value
                            }
                            enabled {
                                boolValue
                            }
                        }
                        ...PhotoAlbumBulkFragment
                    }
                    dateList: children {
                        ...DateListFragment
                    }
                }
            }
        }
    }
    ${PhotoAlbumBulkFragmentDoc}
    ${DateListFragmentDoc}
`;
export const PartiesFragmentDoc = gql`
    fragment PartiesFragment on MultilistField {
        partyList: targetItems {
            id
            name
            ...PartyInfoFragment
        }
    }
    ${PartyInfoFragmentDoc}
`;
export const PagePhotoAlbumBlockFragmentDoc = gql`
    fragment PagePhotoAlbumBlockFragment on PhotoAlbumBlock {
        name
        template {
            name
        }
        parties {
            ...PartiesFragment
        }
    }
    ${PartiesFragmentDoc}
`;
export const PartyIdFragmentDoc = gql`
    fragment PartyIdFragment on PartySchedule {
        name
        template {
            name
        }
        parties {
            targetItems {
                ...PartyInformationFragment
            }
        }
        titleIconOptions {
            value
        }
    }
    ${PartyInformationFragmentDoc}
`;
export const PartyDateFolderFragmentDoc = gql`
    fragment PartyDateFolderFragment on PartyDateFolder {
        template {
            name
        }
        partyCardList: children {
            ...PartyCardListFragment
        }
    }
    ${PartyCardListFragmentDoc}
`;
export const PartIntroBlockFragmentDoc = gql`
    fragment PartIntroBlockFragment on PartyIntroBlock {
        template {
            name
        }
        partyIntroTitle {
            value
        }
        partyIntroContent {
            rendered
        }
    }
`;
export const PartCardBlockFragmentDoc = gql`
    fragment PartCardBlockFragment on PartyCardBlock {
        template {
            name
        }
    }
`;
export const AlbumItemFragmentDoc = gql`
    fragment AlbumItemFragment on PartyAlbumItem {
        name
        template {
            name
        }
        mediaType {
            value
        }
        contentImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        videoSrc {
            value
        }
        mediaCaption {
            value
        }
    }
`;
export const PageAlbumFragmentDoc = gql`
    fragment pageAlbumFragment on PartyAlbumBlock {
        name
        path
        template {
            name
        }
        layoutBlock {
            value
        }
        albumList: children {
            ...AlbumItemFragment
        }
    }
    ${AlbumItemFragmentDoc}
`;
export const VenueMultilistFragmentDoc = gql`
    fragment VenueMultilistFragment on MultilistField {
        name
        venueList: targetItems {
            ...VenueItemFragment
        }
    }
    ${VenueItemFragmentDoc}
`;
export const PageVenueFragmentDoc = gql`
    fragment PageVenueFragment on VenueBlock {
        name
        template {
            name
        }
        blockSubHeader {
            value
        }
        blockHeader {
            value
        }
        blockContent {
            rendered
        }
        buttonText {
            value
        }
        buttonLink {
            value
        }
        buttonEnable {
            boolValue
        }
        titleIconOptions {
            value
        }
        displayVenue {
            ...VenueMultilistFragment
        }
    }
    ${VenueMultilistFragmentDoc}
`;
export const PageImageFragmentDoc = gql`
    fragment PageImageFragment on Image {
        name
        path
        template {
            name
        }
        imageSelection {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        imageCaption {
            value
        }
        imageLightboxEnable {
            boolValue
        }
    }
`;
export const PageRowFragmentDoc = gql`
    fragment PageRowFragment on Row {
        name
        path
        template {
            name
        }
        rowHeader {
            rendered
        }
        rowContent {
            rendered
        }
        titleIconOptions {
            value
        }
        rowLayout {
            value
        }
        buttonAText {
            value
        }
        buttonALink {
            value
        }
        buttonAEnable {
            boolValue
        }
        buttonBText {
            value
        }
        buttonBLink {
            value
        }
        buttonBEnable {
            boolValue
        }
    }
`;
export const CrossSellBannerFragmentDoc = gql`
    fragment CrossSellBannerFragment on CrossSellBanner {
        id
        name
        path
        template {
            name
        }
        bannerType {
            value
        }
        bannerBgImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        titleIconOptions {
            value
        }
        generalHeader {
            value
        }
        generalContent {
            rendered
        }
        generalCtaEnable {
            boolValue
        }
        generalCtaText {
            value
        }
        generalCtaLink {
            value
        }
        partyLink {
            targetItem {
                name
                ... on Party {
                    partyName {
                        value
                    }
                    partyDateText {
                        value
                    }
                }
            }
        }
        partyCtaEnable {
            boolValue
        }
        partyCtaLink {
            value
        }
    }
`;
export const PartyDetailFragmentDoc = gql`
    fragment PartyDetailFragment on PartyDetailPageItem {
        name
        pageTitle {
            value
        }
        pageDescription {
            rendered
        }
        headerBgImage {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
        row: children {
            name
            col: children {
                name
                pageContent: children {
                    ...PartIntroBlockFragment
                    ...PartCardBlockFragment
                    ...pageAlbumFragment
                    ...PageVenueFragment
                    ...PageImageFragment
                    ...PageRowFragment
                    ...CrossSellBannerFragment
                }
            }
        }
    }
    ${PartIntroBlockFragmentDoc}
    ${PartCardBlockFragmentDoc}
    ${PageAlbumFragmentDoc}
    ${PageVenueFragmentDoc}
    ${PageImageFragmentDoc}
    ${PageRowFragmentDoc}
    ${CrossSellBannerFragmentDoc}
`;
export const MenuFragmentDoc = gql`
    fragment MenuFragment on Menu {
        name
        displayText {
            value
        }
        destination {
            value
        }
        linkTo {
            value
        }
        enabled {
            boolValue
        }
    }
`;
export const SubMenuItemFragmentDoc = gql`
    fragment SubMenuItemFragment on SubMenu {
        name
        displayText {
            value
        }
        destination {
            value
        }
        linkTo {
            value
        }
        enabled {
            boolValue
        }
    }
`;
export const MenuItemFragmentDoc = gql`
    fragment MenuItemFragment on Menu {
        ...MenuFragment
        children {
            ...SubMenuItemFragment
        }
    }
    ${MenuFragmentDoc}
    ${SubMenuItemFragmentDoc}
`;
export const SocialMediaIconFragmentDoc = gql`
    fragment SocialMediaIconFragment on SocialMediaItem {
        name
        socialName {
            value
        }
        socialLink {
            value
        }
        socialIcon {
            ... on ImageField {
                src(maxWidth: null)
            }
        }
    }
`;
export const PartnerBlockQueryDocument = gql`
    query PartnerBlockQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...HomePartnerFragment
        }
    }
    ${HomePartnerFragmentDoc}
`;
export const TestimonialBlockQueryDocument = gql`
    query TestimonialBlockQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...HomeTestimonialFragment
        }
    }
    ${HomeTestimonialFragmentDoc}
`;
export const ThreeBlocksQueryDocument = gql`
    query ThreeBlocksQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...HomeThreeFragment
        }
    }
    ${HomeThreeFragmentDoc}
`;
export const HomepageContentSliderQueryDocument = gql`
    query HomepageContentSliderQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...HomepageContentSliderFragment
        }
    }
    ${HomepageContentSliderFragmentDoc}
`;
export const HomepageIgContainerQueryDocument = gql`
    query HomepageIgContainerQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...HomeInstagramFragment
        }
    }
    ${HomeInstagramFragmentDoc}
`;
export const InSiteNavigationDocument = gql`
    query InSiteNavigation($lang: String = "en-US") {
        inSiteNavigation: item(
            path: "/sitecore/content/Sites/HappyWed/SiteNavigations/InSiteNavigation"
            language: $lang
        ) {
            name
            children {
                ...INMenuItemFragment
            }
        }
    }
    ${InMenuItemFragmentDoc}
`;
export const SeoAlbumDetailQueryDocument = gql`
    query SEOAlbumDetailQuery($path: String, $lang: String = "en-US") {
        SEOAlbumDetailItem: item(path: $path, language: $lang) {
            ...SEOAlbumDetailFragment
        }
    }
    ${SeoAlbumDetailFragmentDoc}
`;
export const SeoQueryDocument = gql`
    query SEOQuery($path: String, $lang: String = "en-US") {
        SEOItem: item(path: $path, language: $lang) {
            ...SEOFragment
        }
    }
    ${SeoFragmentDoc}
`;
export const SeoPartyDetailQueryDocument = gql`
    query SEOPartyDetailQuery($path: String, $lang: String = "en-US") {
        SEOPartyDetailItem: item(path: $path, language: $lang) {
            ...SEOPartyDetailFragment
        }
    }
    ${SeoPartyDetailFragmentDoc}
`;
export const AlertPopupsQueryDocument = gql`
    query alertPopupsQuery($lang: String = "en-US") {
        Item: item(path: "/sitecore/content/Sites/HappyWed/AlertPopups", language: $lang) {
            alertList: children {
                ...AlertPopupFragment
            }
        }
    }
    ${AlertPopupFragmentDoc}
`;
export const CrossSellBannerQueryDocument = gql`
    query CrossSellBannerQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...CrossSellBannerFragment
        }
    }
    ${CrossSellBannerFragmentDoc}
`;
export const GeneralPageQueryDocument = gql`
    query generalPageQuery($path: String, $lang: String = "en-US") {
        generalPage: item(path: $path, language: $lang) {
            ...PageFragment
            row: children {
                ...PageRowDomFragment
            }
        }
    }
    ${PageFragmentDoc}
    ${PageRowDomFragmentDoc}
`;
export const GlobalSettingQueryDocument = gql`
    query globalSettingQuery($lang: String!) {
        globalSettings: item(
            path: "/sitecore/content/Sites/HappyWed/SiteConfiguration/GlobalSettings"
            language: $lang
        ) {
            ...GlobalSettingsFragment
        }
    }
    ${GlobalSettingsFragmentDoc}
`;
export const HomepageHeroBlockQueryDocument = gql`
    query HomepageHeroBlockQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            template {
                name
            }
            list: children {
                ...HomePageHeroFragment
            }
        }
    }
    ${HomePageHeroFragmentDoc}
`;
export const PartyInfoBlockQueryDocument = gql`
    query PartyInfoBlockQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...HomePartyPromotionFragment
        }
    }
    ${HomePartyPromotionFragmentDoc}
`;
export const InLineBusModalQueryDocument = gql`
    query InLineBusModalQuery($lang: String = "en-US") {
        content: item(path: "/sitecore/content/Sites/HappyWed/InLineBus", language: $lang) {
            children(includeTemplateIDs: "{83177667-753B-4FF2-B8F2-58E437AC39F5}") {
                name
                ...InLineBusModalFragment
            }
        }
    }
    ${InLineBusModalFragmentDoc}
`;
export const AccordionContainerQueryDocument = gql`
    query AccordionContainerQuery($path: String!, $lang: String!) {
        Item: item(path: $path, language: $lang) {
            ...PageAccordionFragment
        }
    }
    ${PageAccordionFragmentDoc}
`;
export const PartyAlbumBlockQueryDocument = gql`
    query PartyAlbumBlockQuery($path: String!, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...pageAlbumFragment
        }
    }
    ${PageAlbumFragmentDoc}
`;
export const DiningSingleBlockQueryDocument = gql`
    query DiningSingleBlockQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...PageDiningSingleBlockFragment
        }
    }
    ${PageDiningSingleBlockFragmentDoc}
`;
export const ImageQueryDocument = gql`
    query ImageQuery($path: String!, $lang: String!) {
        Item: item(path: $path, language: $lang) {
            ...PageImageFragment
        }
    }
    ${PageImageFragmentDoc}
`;
export const OtherDiningOptionsQueryDocument = gql`
    query OtherDiningOptionsQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...PageOtherDiningFragment
        }
    }
    ${PageOtherDiningFragmentDoc}
`;
export const PhotoAlbumBlockQueryDocument = gql`
    query PhotoAlbumBlockQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            ...PageFragment
            row: children {
                name
                col: children {
                    pageContent: children {
                        path
                        template {
                            name
                        }
                        ...PagePhotoAlbumBlockFragment
                        ...PageRowFragment
                        ...CrossSellBannerFragment
                    }
                }
            }
        }
    }
    ${PageFragmentDoc}
    ${PagePhotoAlbumBlockFragmentDoc}
    ${PageRowFragmentDoc}
    ${CrossSellBannerFragmentDoc}
`;
export const PhotoAlbumBulkQueryDocument = gql`
    query PhotoAlbumBulkQuery($path: String, $lang: String = "en-US") {
        Item: item(path: $path, language: $lang) {
            path
            template {
                name
            }
            ...PhotoAlbumBulkFragment
        }
    }
    ${PhotoAlbumBulkFragmentDoc}
`;
export const RowQueryDocument = gql`
    query RowQuery($path: String!, $lang: String!) {
        Item: item(path: $path, language: $lang) {
            ...PageRowFragment
        }
    }
    ${PageRowFragmentDoc}
`;
export const PageVenueQueryDocument = gql`
    query pageVenueQuery($path: String!, $lang: String!) {
        Item: item(path: $path, language: $lang) {
            ...PageVenueFragment
        }
    }
    ${PageVenueFragmentDoc}
`;
export const PartiesPageQueryDocument = gql`
    query partiesPageQuery($path: String, $lang: String = "en-US") {
        partiesPage: item(path: $path, language: $lang) {
            id
            ...PageFragment
            row: children {
                col: children {
                    pageContent: children {
                        ...PartyIdFragment
                        ...CrossSellBannerFragment
                    }
                }
            }
        }
    }
    ${PageFragmentDoc}
    ${PartyIdFragmentDoc}
    ${CrossSellBannerFragmentDoc}
`;
export const PartyDateFolderQueryDocument = gql`
    query partyDateFolderQuery($path: String, $lang: String = "en-US") {
        partyDateFolder: item(path: $path, language: $lang) {
            ...PartyDateFolderFragment
        }
    }
    ${PartyDateFolderFragmentDoc}
`;
export const PartyDetailQueryDocument = gql`
    query partyDetailQuery($path: String, $lang: String = "en-US") {
        partyDetail: item(path: $path, language: $lang) {
            ...PartyDetailFragment
        }
    }
    ${PartyDetailFragmentDoc}
`;
export const PartyInformationQueryDocument = gql`
    query partyInformationQuery($path: String, $lang: String = "en-US") {
        partyInformation: item(path: $path, language: $lang) {
            id
            ...PageFragment
            ...PartyInformationFragment
        }
    }
    ${PageFragmentDoc}
    ${PartyInformationFragmentDoc}
`;
export const SiteNavigationDocument = gql`
    query siteNavigation($lang: String = "en-US") {
        siteNavigation: item(
            path: "/sitecore/content/Sites/HappyWed/SiteNavigations"
            language: $lang
        ) {
            children {
                ... on Item {
                    name
                    children {
                        ...MenuItemFragment
                    }
                }
            }
        }
    }
    ${MenuItemFragmentDoc}
`;
export const SocialMediaIconQueryDocument = gql`
    query socialMediaIconQuery($lang: String = "en-US") {
        socialMediaIcon: item(
            path: "/sitecore/content/Sites/HappyWed/SiteConfiguration/SocialMedia"
            language: $lang
        ) {
            iocnList: children {
                ...SocialMediaIconFragment
            }
        }
    }
    ${SocialMediaIconFragmentDoc}
`;
export const WhitelistQueryDocument = gql`
    query whitelistQuery($lang: String = "en-US") {
        routes: item(path: "/sitecore/content/Sites/HappyWed/GeneralPage", language: $lang) {
            children {
                name
            }
        }
    }
`;

export type SdkFunctionWrapper = <T>(
    action: (requestHeaders?: Record<string, string>) => Promise<T>,
    operationName: string,
    operationType?: string,
    variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, variables) =>
    action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
    return {
        PartnerBlockQuery(
            variables?: PartnerBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartnerBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartnerBlockQueryResult>(PartnerBlockQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'PartnerBlockQuery',
                'query',
                variables,
            );
        },
        TestimonialBlockQuery(
            variables?: TestimonialBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<TestimonialBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<TestimonialBlockQueryResult>(
                        TestimonialBlockQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'TestimonialBlockQuery',
                'query',
                variables,
            );
        },
        ThreeBlocksQuery(
            variables?: ThreeBlocksQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<ThreeBlocksQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<ThreeBlocksQueryResult>(ThreeBlocksQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'ThreeBlocksQuery',
                'query',
                variables,
            );
        },
        HomepageContentSliderQuery(
            variables?: HomepageContentSliderQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<HomepageContentSliderQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<HomepageContentSliderQueryResult>(
                        HomepageContentSliderQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'HomepageContentSliderQuery',
                'query',
                variables,
            );
        },
        HomepageIgContainerQuery(
            variables?: HomepageIgContainerQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<HomepageIgContainerQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<HomepageIgContainerQueryResult>(
                        HomepageIgContainerQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'HomepageIgContainerQuery',
                'query',
                variables,
            );
        },
        InSiteNavigation(
            variables?: InSiteNavigationQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<InSiteNavigationQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<InSiteNavigationQueryResult>(
                        InSiteNavigationDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'InSiteNavigation',
                'query',
                variables,
            );
        },
        SEOAlbumDetailQuery(
            variables?: SeoAlbumDetailQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<SeoAlbumDetailQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SeoAlbumDetailQueryResult>(
                        SeoAlbumDetailQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'SEOAlbumDetailQuery',
                'query',
                variables,
            );
        },
        SEOQuery(
            variables?: SeoQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<SeoQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SeoQueryResult>(SeoQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'SEOQuery',
                'query',
                variables,
            );
        },
        SEOPartyDetailQuery(
            variables?: SeoPartyDetailQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<SeoPartyDetailQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SeoPartyDetailQueryResult>(
                        SeoPartyDetailQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'SEOPartyDetailQuery',
                'query',
                variables,
            );
        },
        alertPopupsQuery(
            variables?: AlertPopupsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<AlertPopupsQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<AlertPopupsQueryResult>(AlertPopupsQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'alertPopupsQuery',
                'query',
                variables,
            );
        },
        CrossSellBannerQuery(
            variables?: CrossSellBannerQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<CrossSellBannerQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<CrossSellBannerQueryResult>(
                        CrossSellBannerQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'CrossSellBannerQuery',
                'query',
                variables,
            );
        },
        generalPageQuery(
            variables?: GeneralPageQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<GeneralPageQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GeneralPageQueryResult>(GeneralPageQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'generalPageQuery',
                'query',
                variables,
            );
        },
        globalSettingQuery(
            variables: GlobalSettingQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<GlobalSettingQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<GlobalSettingQueryResult>(
                        GlobalSettingQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'globalSettingQuery',
                'query',
                variables,
            );
        },
        HomepageHeroBlockQuery(
            variables?: HomepageHeroBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<HomepageHeroBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<HomepageHeroBlockQueryResult>(
                        HomepageHeroBlockQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'HomepageHeroBlockQuery',
                'query',
                variables,
            );
        },
        PartyInfoBlockQuery(
            variables?: PartyInfoBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartyInfoBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartyInfoBlockQueryResult>(
                        PartyInfoBlockQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'PartyInfoBlockQuery',
                'query',
                variables,
            );
        },
        InLineBusModalQuery(
            variables?: InLineBusModalQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<InLineBusModalQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<InLineBusModalQueryResult>(
                        InLineBusModalQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'InLineBusModalQuery',
                'query',
                variables,
            );
        },
        AccordionContainerQuery(
            variables: AccordionContainerQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<AccordionContainerQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<AccordionContainerQueryResult>(
                        AccordionContainerQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'AccordionContainerQuery',
                'query',
                variables,
            );
        },
        PartyAlbumBlockQuery(
            variables: PartyAlbumBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartyAlbumBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartyAlbumBlockQueryResult>(
                        PartyAlbumBlockQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'PartyAlbumBlockQuery',
                'query',
                variables,
            );
        },
        DiningSingleBlockQuery(
            variables?: DiningSingleBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<DiningSingleBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<DiningSingleBlockQueryResult>(
                        DiningSingleBlockQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'DiningSingleBlockQuery',
                'query',
                variables,
            );
        },
        ImageQuery(
            variables: ImageQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<ImageQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<ImageQueryResult>(ImageQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'ImageQuery',
                'query',
                variables,
            );
        },
        OtherDiningOptionsQuery(
            variables?: OtherDiningOptionsQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<OtherDiningOptionsQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<OtherDiningOptionsQueryResult>(
                        OtherDiningOptionsQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'OtherDiningOptionsQuery',
                'query',
                variables,
            );
        },
        PhotoAlbumBlockQuery(
            variables?: PhotoAlbumBlockQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PhotoAlbumBlockQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PhotoAlbumBlockQueryResult>(
                        PhotoAlbumBlockQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'PhotoAlbumBlockQuery',
                'query',
                variables,
            );
        },
        PhotoAlbumBulkQuery(
            variables?: PhotoAlbumBulkQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PhotoAlbumBulkQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PhotoAlbumBulkQueryResult>(
                        PhotoAlbumBulkQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'PhotoAlbumBulkQuery',
                'query',
                variables,
            );
        },
        RowQuery(
            variables: RowQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<RowQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<RowQueryResult>(RowQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'RowQuery',
                'query',
                variables,
            );
        },
        pageVenueQuery(
            variables: PageVenueQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PageVenueQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PageVenueQueryResult>(PageVenueQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'pageVenueQuery',
                'query',
                variables,
            );
        },
        partiesPageQuery(
            variables?: PartiesPageQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartiesPageQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartiesPageQueryResult>(PartiesPageQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'partiesPageQuery',
                'query',
                variables,
            );
        },
        partyDateFolderQuery(
            variables?: PartyDateFolderQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartyDateFolderQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartyDateFolderQueryResult>(
                        PartyDateFolderQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'partyDateFolderQuery',
                'query',
                variables,
            );
        },
        partyDetailQuery(
            variables?: PartyDetailQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartyDetailQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartyDetailQueryResult>(PartyDetailQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'partyDetailQuery',
                'query',
                variables,
            );
        },
        partyInformationQuery(
            variables?: PartyInformationQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<PartyInformationQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<PartyInformationQueryResult>(
                        PartyInformationQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'partyInformationQuery',
                'query',
                variables,
            );
        },
        siteNavigation(
            variables?: SiteNavigationQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<SiteNavigationQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SiteNavigationQueryResult>(SiteNavigationDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'siteNavigation',
                'query',
                variables,
            );
        },
        socialMediaIconQuery(
            variables?: SocialMediaIconQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<SocialMediaIconQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<SocialMediaIconQueryResult>(
                        SocialMediaIconQueryDocument,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders },
                    ),
                'socialMediaIconQuery',
                'query',
                variables,
            );
        },
        whitelistQuery(
            variables?: WhitelistQueryVariables,
            requestHeaders?: GraphQLClientRequestHeaders,
        ): Promise<WhitelistQueryResult> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.request<WhitelistQueryResult>(WhitelistQueryDocument, variables, {
                        ...requestHeaders,
                        ...wrappedRequestHeaders,
                    }),
                'whitelistQuery',
                'query',
                variables,
            );
        },
    };
}
export type Sdk = ReturnType<typeof getSdk>;
